/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
  "data": {
    "currencies": {
      "ADP": {
        "displayName": {
          "one": "Andoros peseta",
          "other": "Andoros pesetos"
        },
        "narrow": "ADP",
        "symbol": "ADP"
      },
      "AED": {
        "displayName": {
          "few": "JAE dirhamai",
          "many": "JAE dirhamo",
          "one": "JAE dirhamas",
          "other": "JAE dirhamų"
        },
        "narrow": "AED",
        "symbol": "AED"
      },
      "AFA": {
        "displayName": {
          "few": "Afganistano afganiai (1927–2002)",
          "many": "Afganistano afganio (1927–2002)",
          "one": "Afganistano afganis (1927–2002)",
          "other": "Afganistano afganių (1927–2002)"
        },
        "narrow": "AFA",
        "symbol": "AFA"
      },
      "AFN": {
        "displayName": {
          "few": "Afganistano afganiai",
          "many": "Afganistano afganio",
          "one": "Afganistano afganis",
          "other": "Afganistano afganių"
        },
        "narrow": "؋",
        "symbol": "AFN"
      },
      "ALK": {
        "displayName": {
          "few": "Albanijos lekai (1946–1965)",
          "many": "Albanijos leko (1946–1965)",
          "one": "Albanijos lekas (1946–1965)",
          "other": "Albanijos lekų (1946–1965)"
        },
        "narrow": "ALK",
        "symbol": "ALK"
      },
      "ALL": {
        "displayName": {
          "few": "Albanijos lekai",
          "many": "Albanijos leko",
          "one": "Albanijos lekas",
          "other": "Albanijos lekų"
        },
        "narrow": "ALL",
        "symbol": "ALL"
      },
      "AMD": {
        "displayName": {
          "few": "Armėnijos dramai",
          "many": "Armėnijos dramo",
          "one": "Armėnijos dramas",
          "other": "Armėnijos dramų"
        },
        "narrow": "֏",
        "symbol": "AMD"
      },
      "ANG": {
        "displayName": {
          "few": "Olandijos Antilų guldenai",
          "many": "Olandijos Antilų guldeno",
          "one": "Olandijos Antilų guldenas",
          "other": "Olandijos Antilų guldenų"
        },
        "narrow": "ANG",
        "symbol": "ANG"
      },
      "AOA": {
        "displayName": {
          "few": "Angolos kvanzos",
          "many": "Angolos kvanzos",
          "one": "Angolos kvanza",
          "other": "Angolos kvanzų"
        },
        "narrow": "Kz",
        "symbol": "AOA"
      },
      "AOK": {
        "displayName": {
          "few": "Angolos kvanzos (1977–1990)",
          "many": "Angolos kvanzos (1977–1990)",
          "one": "Angolos kvanza (1977–1990)",
          "other": "Angolos kvanzų (1977–1990)"
        },
        "narrow": "AOK",
        "symbol": "AOK"
      },
      "AON": {
        "displayName": {
          "few": "Angolos naujosios kvanzos (1990–2000)",
          "many": "Angolos naujosios kvanzos (1990–2000)",
          "one": "Angolos naujoji kvanza (1990–2000)",
          "other": "Angolos naujųjų kvanzų (1990–2000)"
        },
        "narrow": "AON",
        "symbol": "AON"
      },
      "AOR": {
        "displayName": {
          "few": "Angolos patikslintos kvanzos (1995–1999)",
          "many": "Angolos patikslintos kvanzos (1995–1999)",
          "one": "Angolos patikslinta kvanza (1995–1999)",
          "other": "Angolos patikslintų kvanzų (1995–1999)"
        },
        "narrow": "AOR",
        "symbol": "AOR"
      },
      "ARA": {
        "displayName": {
          "one": "Argentinos austral",
          "other": "Argentinos australs"
        },
        "narrow": "ARA",
        "symbol": "ARA"
      },
      "ARL": {
        "displayName": {
          "other": "Argentinos pesos ley (1970–1983)"
        },
        "narrow": "ARL",
        "symbol": "ARL"
      },
      "ARM": {
        "displayName": {
          "few": "Argentinos pesai (1881–1970)",
          "many": "Argentinos peso (1881–1970)",
          "one": "Argentinos pesas (1881–1970)",
          "other": "Argentinos pesų (1881–1970)"
        },
        "narrow": "ARM",
        "symbol": "ARM"
      },
      "ARP": {
        "displayName": {
          "one": "Argentinos pesas (1983–1985)",
          "other": "Argentinos pesai (1983–1985)"
        },
        "narrow": "ARP",
        "symbol": "ARP"
      },
      "ARS": {
        "displayName": {
          "few": "Argentinos pesai",
          "many": "Argentinos peso",
          "one": "Argentinos pesas",
          "other": "Argentinos pesų"
        },
        "narrow": "$",
        "symbol": "ARS"
      },
      "ATS": {
        "displayName": {
          "few": "Austrijos šilingai",
          "many": "Austrijos šilingo",
          "one": "Austrijos šilingas",
          "other": "Austrijos šilingų"
        },
        "narrow": "ATS",
        "symbol": "ATS"
      },
      "AUD": {
        "displayName": {
          "few": "Australijos doleriai",
          "many": "Australijos dolerio",
          "one": "Australijos doleris",
          "other": "Australijos dolerių"
        },
        "narrow": "$",
        "symbol": "AUD"
      },
      "AWG": {
        "displayName": {
          "few": "Arubos guldenai",
          "many": "Arubos guldeno",
          "one": "Arubos guldenas",
          "other": "Arubos guldenų"
        },
        "narrow": "AWG",
        "symbol": "AWG"
      },
      "AZM": {
        "displayName": {
          "few": "Azerbaidžano manatai (1993–2006)",
          "many": "Azerbaidžano manato (1993–2006)",
          "one": "Azerbaidžano manatas (1993–2006)",
          "other": "Azerbaidžano manatų (1993–2006)"
        },
        "narrow": "AZM",
        "symbol": "AZM"
      },
      "AZN": {
        "displayName": {
          "few": "Azerbaidžano manatai",
          "many": "Azerbaidžano manato",
          "one": "Azerbaidžano manatas",
          "other": "Azerbaidžano manatų"
        },
        "narrow": "₼",
        "symbol": "AZN"
      },
      "BAD": {
        "displayName": {
          "few": "Bosnijos ir Hercegovinos dinarai (1992–1994)",
          "many": "Bosnijos ir Hercegovinos dinaro (1992–1994)",
          "one": "Bosnijos ir Hercegovinos dinaras (1992–1994)",
          "other": "Bosnijos ir Hercegovinos dinarų (1992–1994)"
        },
        "narrow": "BAD",
        "symbol": "BAD"
      },
      "BAM": {
        "displayName": {
          "few": "Bosnijos ir Hercegovinos konvertuojamosios markės",
          "many": "Bosnijos ir Hercegovinos konvertuojamosios markės",
          "one": "Bosnijos ir Hercegovinos konvertuojamoji markė",
          "other": "Bosnijos ir Hercegovinos konvertuojamųjų markių"
        },
        "narrow": "KM",
        "symbol": "BAM"
      },
      "BAN": {
        "displayName": {
          "few": "Bosnijos ir Hercegovinos naujieji dinarai (1994–1997)",
          "many": "Bosnijos ir Hercegovinos naujojo dinaro (1994–1997)",
          "one": "Bosnijos ir Hercegovinos naujasis dinaras (1994–1997)",
          "other": "Bosnijos ir Hercegovinos naujųjų dinarų (1994–1997)"
        },
        "narrow": "BAN",
        "symbol": "BAN"
      },
      "BBD": {
        "displayName": {
          "few": "Barbadoso doleriai",
          "many": "Barbadoso dolerio",
          "one": "Barbadoso doleris",
          "other": "Barbadoso dolerių"
        },
        "narrow": "$",
        "symbol": "BBD"
      },
      "BDT": {
        "displayName": {
          "few": "Bangladešo takos",
          "many": "Bangladešo takos",
          "one": "Bangladešo taka",
          "other": "Bangladešo takų"
        },
        "narrow": "BDT",
        "symbol": "BDT"
      },
      "BEC": {
        "displayName": {
          "few": "Belgijos frankai (konvertuojami)",
          "many": "Belgijos franko (konvertuojamo)",
          "one": "Belgijos frankas (konvertuojamas)",
          "other": "Belgijos frankų (konvertuojamų)"
        },
        "narrow": "BEC",
        "symbol": "BEC"
      },
      "BEF": {
        "displayName": {
          "few": "Belgijos frankai",
          "many": "Belgijos franko",
          "one": "Belgijos frankas",
          "other": "Belgijos frankų"
        },
        "narrow": "BEF",
        "symbol": "BEF"
      },
      "BEL": {
        "displayName": {
          "few": "Belgijos frankai (finansiniai)",
          "many": "Belgijos franko (finansinio)",
          "one": "Belgijos frankas (finansinis)",
          "other": "Belgijos frankų (finansinių)"
        },
        "narrow": "BEL",
        "symbol": "BEL"
      },
      "BGL": {
        "displayName": {
          "few": "Bulgarijos levai (1962–1999)",
          "many": "Bulgarijos levo (1962–1999)",
          "one": "Bulgarijos levas (1962–1999)",
          "other": "Bulgarijos levų (1962–1999)"
        },
        "narrow": "BGL",
        "symbol": "BGL"
      },
      "BGM": {
        "displayName": {
          "one": "Bulgarų socialistų lev",
          "other": "Bulgarų socialistų leva"
        },
        "narrow": "BGM",
        "symbol": "BGM"
      },
      "BGN": {
        "displayName": {
          "few": "Bulgarijos levai",
          "many": "Bulgarijos levo",
          "one": "Bulgarijos levas",
          "other": "Bulgarijos levų"
        },
        "narrow": "BGN",
        "symbol": "BGN"
      },
      "BGO": {
        "displayName": {
          "few": "Bulgarijos levai (1879–1952)",
          "many": "Bulgarijos levo (1879–1952)",
          "one": "Bulgarijos levas (1879–1952)",
          "other": "Bulgarijos levų (1879–1952)"
        },
        "narrow": "BGO",
        "symbol": "BGO"
      },
      "BHD": {
        "displayName": {
          "few": "Bahreino dinarai",
          "many": "Bahreino dinaro",
          "one": "Bahreino dinaras",
          "other": "Bahreino dinarų"
        },
        "narrow": "BHD",
        "symbol": "BHD"
      },
      "BIF": {
        "displayName": {
          "few": "Burundžio frankai",
          "many": "Burundžio franko",
          "one": "Burundžio frankas",
          "other": "Burundžio frankų"
        },
        "narrow": "BIF",
        "symbol": "BIF"
      },
      "BMD": {
        "displayName": {
          "few": "Bermudos doleriai",
          "many": "Bermudos dolerio",
          "one": "Bermudos doleris",
          "other": "Bermudos dolerių"
        },
        "narrow": "$",
        "symbol": "BMD"
      },
      "BND": {
        "displayName": {
          "few": "Brunėjaus doleriai",
          "many": "Brunėjaus dolerio",
          "one": "Brunėjaus doleris",
          "other": "Brunėjaus dolerių"
        },
        "narrow": "$",
        "symbol": "BND"
      },
      "BOB": {
        "displayName": {
          "few": "Bolivijos bolivijanai",
          "many": "Bolivijos bolivijano",
          "one": "Bolivijos bolivijanas",
          "other": "Bolivijos bolivijanų"
        },
        "narrow": "Bs",
        "symbol": "BOB"
      },
      "BOL": {
        "displayName": {
          "few": "Bolivijos bolivijanai (1863–1963)",
          "many": "Bolivijos bolivijano (1863–1963)",
          "one": "Bolivijos bolivijanas (1863–1963)",
          "other": "Bolivijos bolivijanų (1863–1963)"
        },
        "narrow": "BOL",
        "symbol": "BOL"
      },
      "BOP": {
        "displayName": {
          "few": "Bolivijos pesai",
          "many": "Bolivijos peso",
          "one": "Bolivijos pesas",
          "other": "Bolivijos pesų"
        },
        "narrow": "BOP",
        "symbol": "BOP"
      },
      "BOV": {
        "displayName": {
          "few": "Boliviečių mvdols",
          "other": "Bolivijos mvdol"
        },
        "narrow": "BOV",
        "symbol": "BOV"
      },
      "BRB": {
        "displayName": {
          "few": "Brazilijos naujieji kruzeirai (1967–1986)",
          "many": "Brazilijos naujasis kruzeiro (1967–1986)",
          "one": "Brazilijos naujasis kruzeiras (1967–1986)",
          "other": "Brazilijos naujųjų kruzeirų (1967–1986)"
        },
        "narrow": "BRB",
        "symbol": "BRB"
      },
      "BRC": {
        "displayName": {
          "few": "Brazilijos kruzadai (1986–1989)",
          "many": "Brazilijos kruzado (1986–1989)",
          "one": "Brazilijos kruzadas (1986–1989)",
          "other": "Brazilijos kruzadų (1986–1989)"
        },
        "narrow": "BRC",
        "symbol": "BRC"
      },
      "BRE": {
        "displayName": {
          "one": "Brazilijos kruzeiras (1990–1993)",
          "other": "Brazilijos kruzeirai (1990–1993)"
        },
        "narrow": "BRE",
        "symbol": "BRE"
      },
      "BRL": {
        "displayName": {
          "few": "Brazilijos realai",
          "many": "Brazilijos realo",
          "one": "Brazilijos realas",
          "other": "Brazilijos realų"
        },
        "narrow": "R$",
        "symbol": "BRL"
      },
      "BRN": {
        "displayName": {
          "few": "Brazilijos naujieji kruzadai (1989–1990)",
          "many": "Brazilijos naujojo kruzado (1989–1990)",
          "one": "Brazilijos naujasis kruzadas (1989–1990)",
          "other": "Brazilijos naujųjų kruzadų (1989–1990)"
        },
        "narrow": "BRN",
        "symbol": "BRN"
      },
      "BRR": {
        "displayName": {
          "few": "Brazilijos kruzeirai (1993–1994)",
          "many": "Brazilijos kruzeiro (1993–1994)",
          "one": "Brazilijos kruzeiras (1993–1994)",
          "other": "Brazilijos kruzeirų (1993–1994)"
        },
        "narrow": "BRR",
        "symbol": "BRR"
      },
      "BRZ": {
        "displayName": {
          "few": "Brazilijos kruzeirai (1942–1967)",
          "many": "Brazilijos kruzeiro (1942–1967)",
          "one": "Brazilijos kruzeiras (1942–1967)",
          "other": "Brazilijos kruzeirų (1942–1967)"
        },
        "narrow": "BRZ",
        "symbol": "BRZ"
      },
      "BSD": {
        "displayName": {
          "few": "Bahamų doleriai",
          "many": "Bahamų dolerio",
          "one": "Bahamų doleris",
          "other": "Bahamų dolerių"
        },
        "narrow": "$",
        "symbol": "BSD"
      },
      "BTN": {
        "displayName": {
          "few": "Butano ngultrumai",
          "many": "Butano ngultrumo",
          "one": "Butano ngultrumas",
          "other": "Butano ngultrumų"
        },
        "narrow": "BTN",
        "symbol": "BTN"
      },
      "BUK": {
        "displayName": {
          "few": "Birmos kijatai",
          "many": "Birmos kijato",
          "one": "Birmos kijatas",
          "other": "Birmos kijatų"
        },
        "narrow": "BUK",
        "symbol": "BUK"
      },
      "BWP": {
        "displayName": {
          "few": "Botsvanos pulos",
          "many": "Botsvanos pulos",
          "one": "Botsvanos pula",
          "other": "Botsvanos pulų"
        },
        "narrow": "P",
        "symbol": "BWP"
      },
      "BYB": {
        "displayName": {
          "few": "Baltarusijos naujieji rubliai (1994–1999)",
          "many": "Baltarusijos naujojo rublio (1994–1999)",
          "one": "Baltarusijos naujasis rublis (1994–1999)",
          "other": "Baltarusijos naujųjų rublių"
        },
        "narrow": "BYB",
        "symbol": "BYB"
      },
      "BYN": {
        "displayName": {
          "few": "Baltarusijos rubliai",
          "many": "Baltarusijos rublio",
          "one": "Baltarusijos rublis",
          "other": "Baltarusijos rublių"
        },
        "narrow": "Br",
        "symbol": "BYN"
      },
      "BYR": {
        "displayName": {
          "few": "Baltarusijos rubliai (2000–2016)",
          "many": "Baltarusijos rublio (2000–2016)",
          "one": "Baltarusijos rublis (2000–2016)",
          "other": "Baltarusijos rublių (2000–2016)"
        },
        "narrow": "BYR",
        "symbol": "BYR"
      },
      "BZD": {
        "displayName": {
          "few": "Belizo doleriai",
          "many": "Belizo dolerio",
          "one": "Belizo doleris",
          "other": "Belizo dolerių"
        },
        "narrow": "$",
        "symbol": "BZD"
      },
      "CAD": {
        "displayName": {
          "few": "Kanados doleriai",
          "many": "Kanados dolerio",
          "one": "Kanados doleris",
          "other": "Kanados dolerių"
        },
        "narrow": "$",
        "symbol": "CAD"
      },
      "CDF": {
        "displayName": {
          "few": "Kongo frankai",
          "many": "Kongo franko",
          "one": "Kongo frankas",
          "other": "Kongo frankų"
        },
        "narrow": "CDF",
        "symbol": "CDF"
      },
      "CHE": {
        "displayName": {
          "few": "WIR eurai",
          "many": "WIR euro",
          "one": "WIR euras",
          "other": "WIR eurų"
        },
        "narrow": "CHE",
        "symbol": "CHE"
      },
      "CHF": {
        "displayName": {
          "few": "Šveicarijos frankai",
          "many": "Šveicarijos franko",
          "one": "Šveicarijos frankas",
          "other": "Šveicarijos frankų"
        },
        "narrow": "CHF",
        "symbol": "CHF"
      },
      "CHW": {
        "displayName": {
          "few": "WIR frankai",
          "many": "WIR franko",
          "one": "WIR frankas",
          "other": "WIR frankų"
        },
        "narrow": "CHW",
        "symbol": "CHW"
      },
      "CLE": {
        "displayName": {
          "few": "Čilės eskudai",
          "many": "Čilės eskudo",
          "one": "Čilės eskudas",
          "other": "Čilės eskudų"
        },
        "narrow": "CLE",
        "symbol": "CLE"
      },
      "CLF": {
        "displayName": {
          "other": "Čiliečių unidades de fomentos"
        },
        "narrow": "CLF",
        "symbol": "CLF"
      },
      "CLP": {
        "displayName": {
          "few": "Čilės pesai",
          "many": "Čilės peso",
          "one": "Čilės pesas",
          "other": "Čilės pesų"
        },
        "narrow": "$",
        "symbol": "CLP"
      },
      "CNH": {
        "displayName": {
          "few": "Kinijos Užsienio juaniai",
          "many": "Kinijos Užsienio juanio",
          "one": "Kinijos Užsienio juanis",
          "other": "Kinijos Užsienio juanių"
        },
        "narrow": "CNH",
        "symbol": "CNH"
      },
      "CNX": {
        "displayName": {
          "few": "Kinijos \"People\" banko doleriai",
          "many": "Kinijos \"People\" banko dolerio",
          "one": "Kinijos \"People\" banko doleris",
          "other": "Kinijos \"People\" banko dolerių"
        },
        "narrow": "CNX",
        "symbol": "CNX"
      },
      "CNY": {
        "displayName": {
          "few": "Kinijos ženminbi juaniai",
          "many": "Kinijos ženminbi juanio",
          "one": "Kinijos ženminbi juanis",
          "other": "Kinijos ženminbi juanių"
        },
        "narrow": "¥",
        "symbol": "CNY"
      },
      "COP": {
        "displayName": {
          "few": "Kolumbijos pesai",
          "many": "Kolumbijos peso",
          "one": "Kolumbijos pesas",
          "other": "Kolumbijos pesų"
        },
        "narrow": "$",
        "symbol": "COP"
      },
      "COU": {
        "displayName": {
          "one": "unidad de valor realas",
          "other": "unidad de valor realai"
        },
        "narrow": "COU",
        "symbol": "COU"
      },
      "CRC": {
        "displayName": {
          "few": "Kosta Rikos kolonai",
          "many": "Kosta Rikos kolono",
          "one": "Kosta Rikos kolonas",
          "other": "Kosta Rikos kolonų"
        },
        "narrow": "₡",
        "symbol": "CRC"
      },
      "CSD": {
        "displayName": {
          "few": "Serbijos dinarai (2002–2006)",
          "many": "Serbijos dinaro (2002–2006)",
          "one": "Serbijos dinaras (2002–2006)",
          "other": "Serbijos dinarų (2002–2006)"
        },
        "narrow": "CSD",
        "symbol": "CSD"
      },
      "CSK": {
        "displayName": {
          "few": "Čekoslovakų sunkieji korunai",
          "many": "Čekoslovakų sunkiejio koruno",
          "one": "Čekoslovakų sunkusis korunas",
          "other": "Čekoslovakų sunkiejių korunų"
        },
        "narrow": "CSK",
        "symbol": "CSK"
      },
      "CUC": {
        "displayName": {
          "few": "Kubos konvertuojamieji pesai",
          "many": "Kubos konvertuojamojo peso",
          "one": "Kubos konvertuojamasis pesas",
          "other": "Kubos konvertuojamųjų pesų"
        },
        "narrow": "$",
        "symbol": "CUC"
      },
      "CUP": {
        "displayName": {
          "few": "Kubos pesai",
          "many": "Kubos peso",
          "one": "Kubos pesas",
          "other": "Kubos pesų"
        },
        "narrow": "$",
        "symbol": "CUP"
      },
      "CVE": {
        "displayName": {
          "few": "Žaliojo Kyšulio eskudai",
          "many": "Žaliojo Kyšulio eskudo",
          "one": "Žaliojo Kyšulio eskudas",
          "other": "Žaliojo Kyšulio eskudų"
        },
        "narrow": "CVE",
        "symbol": "CVE"
      },
      "CYP": {
        "displayName": {
          "few": "Kipro svarai",
          "many": "Kipro svaro",
          "one": "Kipro svaras",
          "other": "Kipro svarų"
        },
        "narrow": "CYP",
        "symbol": "CYP"
      },
      "CZK": {
        "displayName": {
          "few": "Čekijos kronos",
          "many": "Čekijos kronos",
          "one": "Čekijos krona",
          "other": "Čekijos kronų"
        },
        "narrow": "Kč",
        "symbol": "CZK"
      },
      "DDM": {
        "displayName": {
          "one": "Rytų Vokietijos markė",
          "other": "Rytų Vokietijos markės"
        },
        "narrow": "DDM",
        "symbol": "DDM"
      },
      "DEM": {
        "displayName": {
          "one": "Vokietijos markė",
          "other": "Vokietijos markės"
        },
        "narrow": "DEM",
        "symbol": "DEM"
      },
      "DJF": {
        "displayName": {
          "few": "Džibučio frankai",
          "many": "Džibučio franko",
          "one": "Džibučio frankas",
          "other": "Džibučio frankų"
        },
        "narrow": "DJF",
        "symbol": "DJF"
      },
      "DKK": {
        "displayName": {
          "few": "Danijos kronos",
          "many": "Danijos kronos",
          "one": "Danijos krona",
          "other": "Danijos kronų"
        },
        "narrow": "kr",
        "symbol": "DKK"
      },
      "DOP": {
        "displayName": {
          "few": "Dominikos pesai",
          "many": "Dominikos peso",
          "one": "Dominikos pesas",
          "other": "Dominikos pesų"
        },
        "narrow": "$",
        "symbol": "DOP"
      },
      "DZD": {
        "displayName": {
          "few": "Alžyro dinarai",
          "many": "Alžyro dinaro",
          "one": "Alžyro dinaras",
          "other": "Alžyro dinarų"
        },
        "narrow": "DZD",
        "symbol": "DZD"
      },
      "ECS": {
        "displayName": {
          "one": "Ekvadoro sucre",
          "other": "Ekvadoro sucres"
        },
        "narrow": "ECS",
        "symbol": "ECS"
      },
      "ECV": {
        "displayName": {
          "other": "Ekvadoro unidads de narsa Constante (UVC)"
        },
        "narrow": "ECV",
        "symbol": "ECV"
      },
      "EEK": {
        "displayName": {
          "few": "Estijos kronos",
          "many": "Estijos kronos",
          "one": "Estijos krona",
          "other": "Estijos kronų"
        },
        "narrow": "EEK",
        "symbol": "EEK"
      },
      "EGP": {
        "displayName": {
          "few": "Egipto svarai",
          "many": "Egipto svaro",
          "one": "Egipto svaras",
          "other": "Egipto svarų"
        },
        "narrow": "E£",
        "symbol": "EGP"
      },
      "ERN": {
        "displayName": {
          "few": "Eritrėjos nakfos",
          "many": "Eritrėjos nakfos",
          "one": "Eritrėjos nakfa",
          "other": "Eritrėjos nakfų"
        },
        "narrow": "ERN",
        "symbol": "ERN"
      },
      "ESA": {
        "displayName": {
          "one": "Ispanų pesetas (A sąskaita)",
          "other": "Ispanų pesetai (A sąskaita)"
        },
        "narrow": "ESA",
        "symbol": "ESA"
      },
      "ESB": {
        "displayName": {
          "one": "Ispanų pesetas (konvertuojama sąskaita)",
          "other": "Ispanų pesetai (konvertuojama sąskaita)"
        },
        "narrow": "ESB",
        "symbol": "ESB"
      },
      "ESP": {
        "displayName": {
          "one": "Ispanų pesetas",
          "other": "Ispanų pesetai"
        },
        "narrow": "₧",
        "symbol": "ESP"
      },
      "ETB": {
        "displayName": {
          "few": "Etiopijos birai",
          "many": "Etiopijos biro",
          "one": "Etiopijos biras",
          "other": "Etiopijos birų"
        },
        "narrow": "ETB",
        "symbol": "ETB"
      },
      "EUR": {
        "displayName": {
          "few": "eurai",
          "many": "euro",
          "one": "euras",
          "other": "eurų"
        },
        "narrow": "€",
        "symbol": "€"
      },
      "FIM": {
        "displayName": {
          "one": "Suomijos markė",
          "other": "Suomijos markės"
        },
        "narrow": "FIM",
        "symbol": "FIM"
      },
      "FJD": {
        "displayName": {
          "few": "Fidžio doleriai",
          "many": "Fidžio dolerio",
          "one": "Fidžio doleris",
          "other": "Fidžio dolerių"
        },
        "narrow": "$",
        "symbol": "FJD"
      },
      "FKP": {
        "displayName": {
          "few": "Falklando salų svarai",
          "many": "Falklando salų svaro",
          "one": "Falklando salų svaras",
          "other": "Falklando salų svarų"
        },
        "narrow": "£",
        "symbol": "FKP"
      },
      "FRF": {
        "displayName": {
          "few": "Prancūzijos frankai",
          "many": "Prancūzijos franko",
          "one": "Prancūzijos frankas",
          "other": "Prancūzijos frankų"
        },
        "narrow": "FRF",
        "symbol": "FRF"
      },
      "GBP": {
        "displayName": {
          "few": "Didžiosios Britanijos svarai",
          "many": "Didžiosios Britanijos svaro",
          "one": "Didžiosios Britanijos svaras",
          "other": "Didžiosios Britanijos svarų"
        },
        "narrow": "£",
        "symbol": "GBP"
      },
      "GEK": {
        "displayName": {
          "one": "Gruzinų kupon larit",
          "other": "Gruzinų kupon larits"
        },
        "narrow": "GEK",
        "symbol": "GEK"
      },
      "GEL": {
        "displayName": {
          "few": "Gruzijos lariai",
          "many": "Gruzijos lario",
          "one": "Gruzijos laris",
          "other": "Gruzijos larių"
        },
        "narrow": "₾",
        "symbol": "GEL"
      },
      "GHC": {
        "displayName": {
          "few": "Ganos sedžiai (1979–2007)",
          "many": "Ganos sedžio (1979–2007)",
          "one": "Ganos sedis (1979–2007)",
          "other": "Ganos sedžių (1979–2007)"
        },
        "narrow": "GHC",
        "symbol": "GHC"
      },
      "GHS": {
        "displayName": {
          "few": "Ganos sedžiai",
          "many": "Ganos sedžio",
          "one": "Ganos sedis",
          "other": "Ganos sedžių"
        },
        "narrow": "GH₵",
        "symbol": "GHS"
      },
      "GIP": {
        "displayName": {
          "few": "Gibraltaro svarai",
          "many": "Gibraltaro svaro",
          "one": "Gibraltaro svaras",
          "other": "Gibraltaro svarų"
        },
        "narrow": "£",
        "symbol": "GIP"
      },
      "GMD": {
        "displayName": {
          "few": "Gambijos dalasiai",
          "many": "Gambijos dalasio",
          "one": "Gambijos dalasis",
          "other": "Gambijos dalasių"
        },
        "narrow": "GMD",
        "symbol": "GMD"
      },
      "GNF": {
        "displayName": {
          "few": "Gvinėjos frankai",
          "many": "Gvinėjos franko",
          "one": "Gvinėjos frankas",
          "other": "Gvinėjos frankų"
        },
        "narrow": "FG",
        "symbol": "GNF"
      },
      "GNS": {
        "displayName": {
          "few": "Gvinėjos syliai",
          "one": "Gvinėjos sylis",
          "other": "Gvinėjos sylio"
        },
        "narrow": "GNS",
        "symbol": "GNS"
      },
      "GQE": {
        "displayName": {
          "other": "Pusiaujo Guinean ekwele"
        },
        "narrow": "GQE",
        "symbol": "GQE"
      },
      "GRD": {
        "displayName": {
          "one": "Graikijos drachma",
          "other": "Graikijos drachmos"
        },
        "narrow": "GRD",
        "symbol": "GRD"
      },
      "GTQ": {
        "displayName": {
          "few": "Gvatemalos ketcaliai",
          "many": "Gvatemalos ketcalio",
          "one": "Gvatemalos ketcalis",
          "other": "Gvatemalos ketcalių"
        },
        "narrow": "Q",
        "symbol": "GTQ"
      },
      "GWE": {
        "displayName": {
          "few": "Portugalijos Gvinėjos eskudai",
          "many": "Portugalijos Gvinėjos eskudo",
          "one": "Portugalijos Gvinėjos eskudas",
          "other": "Portugalijos Gvinėjos eskudų"
        },
        "narrow": "GWE",
        "symbol": "GWE"
      },
      "GWP": {
        "displayName": {
          "many": "Bisau Gvinėjos peso",
          "one": "Bisau Gvinėjos pesas",
          "other": "Bisau Gvinėjos pesai"
        },
        "narrow": "GWP",
        "symbol": "GWP"
      },
      "GYD": {
        "displayName": {
          "few": "Gajanos doleriai",
          "many": "Gajanos dolerio",
          "one": "Gajanos doleris",
          "other": "Gajanos dolerių"
        },
        "narrow": "$",
        "symbol": "GYD"
      },
      "HKD": {
        "displayName": {
          "few": "Honkongo doleriai",
          "many": "Honkongo dolerio",
          "one": "Honkongo doleris",
          "other": "Honkongo dolerių"
        },
        "narrow": "$",
        "symbol": "HKD"
      },
      "HNL": {
        "displayName": {
          "few": "Hondūro lempiros",
          "many": "Hondūro lempiros",
          "one": "Hondūro lempira",
          "other": "Hondūro lempirų"
        },
        "narrow": "L",
        "symbol": "HNL"
      },
      "HRD": {
        "displayName": {
          "few": "Krotaijos dinarai",
          "many": "Kroatijos dinaro",
          "one": "Kroatijos dinaras",
          "other": "Kroatijos dinarų"
        },
        "narrow": "HRD",
        "symbol": "HRD"
      },
      "HRK": {
        "displayName": {
          "few": "Kroatijos kunos",
          "many": "Kroatijos kunos",
          "one": "Kroatijos kuna",
          "other": "Kroatijos kunų"
        },
        "narrow": "kn",
        "symbol": "HRK"
      },
      "HTG": {
        "displayName": {
          "few": "Haičio gurdai",
          "many": "Haičio gurdo",
          "one": "Haičio gurdas",
          "other": "Haičio gurdų"
        },
        "narrow": "HTG",
        "symbol": "HTG"
      },
      "HUF": {
        "displayName": {
          "few": "Vengrijos forintai",
          "many": "Vengrijos forinto",
          "one": "Vengrijos forintas",
          "other": "Vengrijos forintų"
        },
        "narrow": "Ft",
        "symbol": "HUF"
      },
      "IDR": {
        "displayName": {
          "few": "Indonezijos rupijos",
          "many": "Indonezijos rupijos",
          "one": "Indonezijos rupija",
          "other": "Indonezijos rupijų"
        },
        "narrow": "Rp",
        "symbol": "IDR"
      },
      "IEP": {
        "displayName": {
          "few": "Airijos svarai",
          "many": "Airijos svaro",
          "one": "Airijos svaras",
          "other": "Airijos svarų"
        },
        "narrow": "IEP",
        "symbol": "IEP"
      },
      "ILP": {
        "displayName": {
          "few": "Izraelio svarai",
          "many": "Izraelio svaro",
          "one": "Izraelio svaras",
          "other": "Izraelio svarų"
        },
        "narrow": "ILP",
        "symbol": "ILP"
      },
      "ILR": {
        "displayName": {
          "few": "Izraelio šekeliai (1980–1985)",
          "many": "Izraelio šekelio (1980–1985)",
          "one": "Izraelio šekelis (1980–1985)",
          "other": "Izraelio šekelių (1980–1985)"
        },
        "narrow": "ILR",
        "symbol": "ILR"
      },
      "ILS": {
        "displayName": {
          "few": "Izraelio naujieji šekeliai",
          "many": "Izraelio naujojo šekelio",
          "one": "Izraelio naujasis šekelis",
          "other": "Izraelio naujųjų šekelių"
        },
        "narrow": "ILS",
        "symbol": "ILS"
      },
      "INR": {
        "displayName": {
          "few": "Indijos rupijos",
          "many": "Indijos rupijos",
          "one": "Indijos rupija",
          "other": "Indijos rupijų"
        },
        "narrow": "INR",
        "symbol": "INR"
      },
      "IQD": {
        "displayName": {
          "few": "Irako dinarai",
          "many": "Irako dinaro",
          "one": "Irako dinaras",
          "other": "Irako dinarų"
        },
        "narrow": "IQD",
        "symbol": "IQD"
      },
      "IRR": {
        "displayName": {
          "few": "Irano rialai",
          "many": "Irano rialo",
          "one": "Irano rialas",
          "other": "Irano rialų"
        },
        "narrow": "IRR",
        "symbol": "IRR"
      },
      "ISJ": {
        "displayName": {
          "few": "Islandijos kronos (1918–1981)",
          "many": "Islandijos kronos (1918–1981)",
          "one": "Islandijos krona (1918–1981)",
          "other": "Islandijos kronų (1918–1981)"
        },
        "narrow": "ISJ",
        "symbol": "ISJ"
      },
      "ISK": {
        "displayName": {
          "few": "Islandijos kronos",
          "many": "Islandijos kronos",
          "one": "Islandijos krona",
          "other": "Islandijos kronų"
        },
        "narrow": "kr",
        "symbol": "ISK"
      },
      "ITL": {
        "displayName": {
          "few": "Italijos liros",
          "many": "Italijos liros",
          "one": "Italijos lira",
          "other": "Italijos lirų"
        },
        "narrow": "ITL",
        "symbol": "ITL"
      },
      "JMD": {
        "displayName": {
          "few": "Jamaikos doleriai",
          "many": "Jamaikos dolerio",
          "one": "Jamaikos doleris",
          "other": "Jamaikos dolerių"
        },
        "narrow": "$",
        "symbol": "JMD"
      },
      "JOD": {
        "displayName": {
          "few": "Jordanijos dinarai",
          "many": "Jordanijos dinaro",
          "one": "Jordanijos dinaras",
          "other": "Jordanijos dinarų"
        },
        "narrow": "JOD",
        "symbol": "JOD"
      },
      "JPY": {
        "displayName": {
          "few": "Japonijos jenos",
          "many": "Japonijos jenos",
          "one": "Japonijos jena",
          "other": "Japonijos jenų"
        },
        "narrow": "¥",
        "symbol": "JPY"
      },
      "KES": {
        "displayName": {
          "few": "Kenijos šilingai",
          "many": "Kenijos šilingo",
          "one": "Kenijos šilingas",
          "other": "Kenijos šilingų"
        },
        "narrow": "KES",
        "symbol": "KES"
      },
      "KGS": {
        "displayName": {
          "few": "Kirgizijos somai",
          "many": "Kirgizijos somo",
          "one": "Kirgizijos somas",
          "other": "Kirgizijos somų"
        },
        "narrow": "KGS",
        "symbol": "KGS"
      },
      "KHR": {
        "displayName": {
          "few": "Kambodžos rieliai",
          "many": "Kambodžos rielio",
          "one": "Kambodžos rielis",
          "other": "Kambodžos rielių"
        },
        "narrow": "KHR",
        "symbol": "KHR"
      },
      "KMF": {
        "displayName": {
          "few": "Komoro frankai",
          "many": "Komoro franko",
          "one": "Komoro frankas",
          "other": "Komoro frankų"
        },
        "narrow": "CF",
        "symbol": "KMF"
      },
      "KPW": {
        "displayName": {
          "few": "Šiaurės Korėjos vonai",
          "many": "Šiaurės Korėjos vono",
          "one": "Šiaurės Korėjos vonas",
          "other": "Šiaurės Korėjos vonų"
        },
        "narrow": "₩",
        "symbol": "KPW"
      },
      "KRH": {
        "displayName": {
          "few": "Pietų Korėjos hwanai (1953–1962)",
          "many": "Pietų Korėjos hwano (1953–1962)",
          "one": "Pietų Korėjos hwanas (1953–1962)",
          "other": "Pietų Korėjos hwanų (1953–1962)"
        },
        "narrow": "KRH",
        "symbol": "KRH"
      },
      "KRO": {
        "displayName": {
          "few": "Pietų Korėjos vonai (1945–1953)",
          "many": "Pietų Korėjos vono (1945–1953)",
          "one": "Pietų Korėjos vonas (1945–1953)",
          "other": "Pietų Korėjos vonų (1945–1953)"
        },
        "narrow": "KRO",
        "symbol": "KRO"
      },
      "KRW": {
        "displayName": {
          "few": "Pietų Korėjos vonai",
          "many": "Pietų Korėjos vono",
          "one": "Pietų Korėjos vonas",
          "other": "Pietų Korėjos vonų"
        },
        "narrow": "₩",
        "symbol": "KRW"
      },
      "KWD": {
        "displayName": {
          "few": "Kuveito dinarai",
          "many": "Kuveito dinaro",
          "one": "Kuveito dinaras",
          "other": "Kuveito dinarų"
        },
        "narrow": "KWD",
        "symbol": "KWD"
      },
      "KYD": {
        "displayName": {
          "few": "Kaimanų salų doleriai",
          "many": "Kaimanų salų dolerio",
          "one": "Kaimanų salų doleris",
          "other": "Kaimanų salų dolerių"
        },
        "narrow": "$",
        "symbol": "KYD"
      },
      "KZT": {
        "displayName": {
          "few": "Kazachstano tengės",
          "many": "Kazachstano tengės",
          "one": "Kazachstano tengė",
          "other": "Kazachstano tengių"
        },
        "narrow": "₸",
        "symbol": "KZT"
      },
      "LAK": {
        "displayName": {
          "few": "Laoso kipai",
          "many": "Laoso kipo",
          "one": "Laoso kipas",
          "other": "Laoso kipų"
        },
        "narrow": "LAK",
        "symbol": "LAK"
      },
      "LBP": {
        "displayName": {
          "few": "Libano svarai",
          "many": "Libano svaro",
          "one": "Libano svaras",
          "other": "Libano svarų"
        },
        "narrow": "L£",
        "symbol": "LBP"
      },
      "LKR": {
        "displayName": {
          "few": "Šri Lankos rupijos",
          "many": "Šri Lankos rupijos",
          "one": "Šri Lankos rupija",
          "other": "Šri Lankos rupijų"
        },
        "narrow": "Rs",
        "symbol": "LKR"
      },
      "LRD": {
        "displayName": {
          "few": "Liberijos doleriai",
          "many": "Liberijos dolerio",
          "one": "Liberijos doleris",
          "other": "Liberijos dolerių"
        },
        "narrow": "$",
        "symbol": "LRD"
      },
      "LSL": {
        "displayName": {
          "other": "Lesoto lotis"
        },
        "narrow": "LSL",
        "symbol": "LSL"
      },
      "LTL": {
        "displayName": {
          "few": "Lietuvos litai",
          "many": "Lietuvos lito",
          "one": "Lietuvos litas",
          "other": "Lietuvos litų"
        },
        "narrow": "Lt",
        "symbol": "LTL"
      },
      "LTT": {
        "displayName": {
          "one": "Lietuvos talonas",
          "other": "Lietuvos talonai"
        },
        "narrow": "LTT",
        "symbol": "LTT"
      },
      "LUC": {
        "displayName": {
          "few": "Liuksemburgo konvertuojami frankai",
          "many": "Liuksemburgo konvertuojamo franko",
          "one": "Liuksemburgo konvertuojas frankas",
          "other": "Liuksemburgo konvertuojamų frankų"
        },
        "narrow": "LUC",
        "symbol": "LUC"
      },
      "LUF": {
        "displayName": {
          "few": "Liuksemburgo frankai",
          "many": "Liuksemburgo franko",
          "one": "Liuksemburgo frankas",
          "other": "Liuksemburgo frankų"
        },
        "narrow": "LUF",
        "symbol": "LUF"
      },
      "LUL": {
        "displayName": {
          "few": "Liuksemburgo finansiniai frankai",
          "many": "Liuksemburgo finansinio franko",
          "one": "Liuksemburgo finansinis frankas",
          "other": "Liuksemburgo finansinių frankų"
        },
        "narrow": "LUL",
        "symbol": "LUL"
      },
      "LVL": {
        "displayName": {
          "few": "Latvijos latai",
          "many": "Latvijos lato",
          "one": "Latvijos latas",
          "other": "Latvijos latų"
        },
        "narrow": "Ls",
        "symbol": "LVL"
      },
      "LVR": {
        "displayName": {
          "few": "Latvijos rubliai",
          "many": "Latvijos rublio",
          "one": "Latvijos rublis",
          "other": "Latvijos rublių"
        },
        "narrow": "LVR",
        "symbol": "LVR"
      },
      "LYD": {
        "displayName": {
          "few": "Libijos dinarai",
          "many": "Libijos dinaro",
          "one": "Libijos dinaras",
          "other": "Libijos dinarų"
        },
        "narrow": "LYD",
        "symbol": "LYD"
      },
      "MAD": {
        "displayName": {
          "few": "Maroko dirhamai",
          "many": "Maroko dirhamo",
          "one": "Maroko dirhamas",
          "other": "Maroko dirhamų"
        },
        "narrow": "MAD",
        "symbol": "MAD"
      },
      "MAF": {
        "displayName": {
          "few": "Maroko frankai",
          "many": "Maroko franko",
          "one": "Maroko frankas",
          "other": "Maroko frankų"
        },
        "narrow": "MAF",
        "symbol": "MAF"
      },
      "MCF": {
        "displayName": {
          "few": "Monegasque frankai",
          "many": "Monegasque franko",
          "one": "Monegasque frankas",
          "other": "Monegasque frankų"
        },
        "narrow": "MCF",
        "symbol": "MCF"
      },
      "MDC": {
        "displayName": {
          "other": "Moldovų cupon"
        },
        "narrow": "MDC",
        "symbol": "MDC"
      },
      "MDL": {
        "displayName": {
          "few": "Moldovos lėjos",
          "many": "Moldovos lėjos",
          "one": "Moldovos lėja",
          "other": "Moldovos lėjų"
        },
        "narrow": "MDL",
        "symbol": "MDL"
      },
      "MGA": {
        "displayName": {
          "few": "Madagaskaro ariariai",
          "many": "Madagaskaro ariario",
          "one": "Madagaskaro ariaris",
          "other": "Madagaskaro ariarių"
        },
        "narrow": "Ar",
        "symbol": "MGA"
      },
      "MGF": {
        "displayName": {
          "few": "Madagaskaro frankai",
          "many": "Madagaskaro franko",
          "one": "Madagaskaro frankas",
          "other": "Madagaskaro frankų"
        },
        "narrow": "MGF",
        "symbol": "MGF"
      },
      "MKD": {
        "displayName": {
          "few": "Makedonijos denarai",
          "many": "Makedonijos denaro",
          "one": "Makedonijos denaras",
          "other": "Makedonijos denarų"
        },
        "narrow": "MKD",
        "symbol": "MKD"
      },
      "MKN": {
        "displayName": {
          "few": "Makedonijos denarai (1992–1993)",
          "many": "Makedonijos denaro (1992–1993)",
          "one": "Makedonijos denaras (1992–1993)",
          "other": "Makedonijos denarų (1992–1993)"
        },
        "narrow": "MKN",
        "symbol": "MKN"
      },
      "MLF": {
        "displayName": {
          "few": "Malio frankai",
          "many": "Malio franko",
          "one": "Malio frankas",
          "other": "Malio frankų"
        },
        "narrow": "MLF",
        "symbol": "MLF"
      },
      "MMK": {
        "displayName": {
          "few": "Mianmaro kijatai",
          "many": "Mianmaro kijato",
          "one": "Mianmaro kijatas",
          "other": "Mianmaro kijatų"
        },
        "narrow": "K",
        "symbol": "MMK"
      },
      "MNT": {
        "displayName": {
          "few": "Mongolijos tugrikai",
          "many": "Mongolijos tugriko",
          "one": "Mongolijos tugrikas",
          "other": "Mongolijos tugrikų"
        },
        "narrow": "MNT",
        "symbol": "MNT"
      },
      "MOP": {
        "displayName": {
          "few": "Makao patakos",
          "many": "Makao patakos",
          "one": "Makao pataka",
          "other": "Makao patakų"
        },
        "narrow": "MOP",
        "symbol": "MOP"
      },
      "MRO": {
        "displayName": {
          "few": "Mauritanijos ugijos (1973–2017)",
          "many": "Mauritanijos ugijos (1973–2017)",
          "one": "Mauritanijos ugija (1973–2017)",
          "other": "Mauritanijos ugijų (1973–2017)"
        },
        "narrow": "MRO",
        "symbol": "MRO"
      },
      "MRU": {
        "displayName": {
          "few": "Mauritanijos ugijos",
          "many": "Mauritanijos ugijos",
          "one": "Mauritanijos ugija",
          "other": "Mauritanijos ugijų"
        },
        "narrow": "MRU",
        "symbol": "MRU"
      },
      "MTL": {
        "displayName": {
          "other": "Maltos lira"
        },
        "narrow": "MTL",
        "symbol": "MTL"
      },
      "MTP": {
        "displayName": {
          "few": "Maltos svarai",
          "many": "Maltos svaro",
          "one": "Maltos svaras",
          "other": "Maltos svarų"
        },
        "narrow": "MTP",
        "symbol": "MTP"
      },
      "MUR": {
        "displayName": {
          "few": "Mauricijaus rupijos",
          "many": "Mauricijaus rupijos",
          "one": "Mauricijaus rupija",
          "other": "Mauricijaus rupijų"
        },
        "narrow": "Rs",
        "symbol": "MUR"
      },
      "MVP": {
        "displayName": {
          "one": "Maldyvų rupija",
          "other": "Maldyvų rupijos"
        },
        "narrow": "MVP",
        "symbol": "MVP"
      },
      "MVR": {
        "displayName": {
          "few": "Maldyvų rufijos",
          "many": "Maldyvų rufijos",
          "one": "Maldyvų rufija",
          "other": "Maldyvų rufijų"
        },
        "narrow": "MVR",
        "symbol": "MVR"
      },
      "MWK": {
        "displayName": {
          "few": "Malavio kvačos",
          "many": "Malavio kvačos",
          "one": "Malavio kvača",
          "other": "Malavio kvačų"
        },
        "narrow": "MWK",
        "symbol": "MWK"
      },
      "MXN": {
        "displayName": {
          "few": "Meksikos pesai",
          "many": "Meksikos peso",
          "one": "Meksikos pesas",
          "other": "Meksikos pesų"
        },
        "narrow": "$",
        "symbol": "MXN"
      },
      "MXP": {
        "displayName": {
          "few": "Meksikos sidabriniai pesai (1861–1992)",
          "many": "Meksikos sidabrino peso (1861–1992)",
          "one": "Meksikos sidabrinis pesas (1861–1992)",
          "other": "Meksikos sidabrinių pesų (1861–1992)"
        },
        "narrow": "MXP",
        "symbol": "MXP"
      },
      "MXV": {
        "displayName": {
          "one": "Meksikos unidad de inversija (UDI)",
          "other": "Meksikos unidads de inversija (UDI)"
        },
        "narrow": "MXV",
        "symbol": "MXV"
      },
      "MYR": {
        "displayName": {
          "few": "Malaizijos ringitai",
          "many": "Malaizijos ringito",
          "one": "Malaizijos ringitas",
          "other": "Malaizijos ringitų"
        },
        "narrow": "RM",
        "symbol": "MYR"
      },
      "MZE": {
        "displayName": {
          "few": "Mozambiko eskudai",
          "many": "Mozambiko eskudo",
          "one": "Mozambiko eskudas",
          "other": "Mozambiko eskudų"
        },
        "narrow": "MZE",
        "symbol": "MZE"
      },
      "MZM": {
        "displayName": {
          "few": "Mozambiko metikaliai (1980–2006)",
          "many": "Mozambiko metikalio (1980–2006)",
          "one": "Mozambiko metikalis (1980–2006)",
          "other": "Mozambiko metikalių (1980–2006)"
        },
        "narrow": "MZM",
        "symbol": "MZM"
      },
      "MZN": {
        "displayName": {
          "few": "Mozambiko metikaliai",
          "many": "Mozambiko metikalio",
          "one": "Mozambiko metikalis",
          "other": "Mozambiko metikalių"
        },
        "narrow": "MZN",
        "symbol": "MZN"
      },
      "NAD": {
        "displayName": {
          "few": "Namibijos doleriai",
          "many": "Namibijos dolerio",
          "one": "Namibijos doleris",
          "other": "Namibijos dolerių"
        },
        "narrow": "$",
        "symbol": "NAD"
      },
      "NGN": {
        "displayName": {
          "few": "Nigerijos nairos",
          "many": "Nigerijos nairos",
          "one": "Nigerijos naira",
          "other": "Nigerijos nairų"
        },
        "narrow": "₦",
        "symbol": "NGN"
      },
      "NIC": {
        "displayName": {
          "few": "Nikaragvos kordobai (1988–1991)",
          "many": "Nikaragvos kordobos (1988–1991)",
          "one": "Nikaragvos kordoba (1988–1991)",
          "other": "Nikaragvos kordobų (1988–1991)"
        },
        "narrow": "NIC",
        "symbol": "NIC"
      },
      "NIO": {
        "displayName": {
          "few": "Nikaragvos kordobos",
          "many": "Nikaragvos kordobos",
          "one": "Nikaragvos kordoba",
          "other": "Nikaragvos kordobų"
        },
        "narrow": "C$",
        "symbol": "NIO"
      },
      "NLG": {
        "displayName": {
          "few": "Nyderlandų guldenai",
          "many": "Nyderlandų guldeno",
          "one": "Nyderlandų guldenas",
          "other": "Nyderlandų guldenų"
        },
        "narrow": "NLG",
        "symbol": "NLG"
      },
      "NOK": {
        "displayName": {
          "few": "Norvegijos kronos",
          "many": "Norvegijos kronos",
          "one": "Norvegijos krona",
          "other": "Norvegijos kronų"
        },
        "narrow": "kr",
        "symbol": "NOK"
      },
      "NPR": {
        "displayName": {
          "few": "Nepalo rupijos",
          "many": "Nepalo rupijos",
          "one": "Nepalo rupija",
          "other": "Nepalo rupijų"
        },
        "narrow": "Rs",
        "symbol": "NPR"
      },
      "NZD": {
        "displayName": {
          "few": "Naujosios Zelandijos doleriai",
          "many": "Naujosios Zelandijos dolerio",
          "one": "Naujosios Zelandijos doleris",
          "other": "Naujosios Zelandijos dolerių"
        },
        "narrow": "$",
        "symbol": "NZD"
      },
      "OMR": {
        "displayName": {
          "few": "Omano rialai",
          "many": "Omano rialo",
          "one": "Omano rialas",
          "other": "Omano rialų"
        },
        "narrow": "OMR",
        "symbol": "OMR"
      },
      "PAB": {
        "displayName": {
          "few": "Panamos balbojos",
          "many": "Panamos balbojos",
          "one": "Panamos balboja",
          "other": "Panamos balbojų"
        },
        "narrow": "PAB",
        "symbol": "PAB"
      },
      "PEI": {
        "displayName": {
          "one": "Peru inti",
          "other": "Peru intis"
        },
        "narrow": "PEI",
        "symbol": "PEI"
      },
      "PEN": {
        "displayName": {
          "few": "Peru soliai",
          "many": "Peru solio",
          "one": "Peru solis",
          "other": "Peru solių"
        },
        "narrow": "PEN",
        "symbol": "PEN"
      },
      "PES": {
        "displayName": {
          "few": "Peru soliai (1863–1965)",
          "many": "Peru solio (1863–1965)",
          "one": "Peru solis (1863–1965)",
          "other": "Peru solių (1863–1965)"
        },
        "narrow": "PES",
        "symbol": "PES"
      },
      "PGK": {
        "displayName": {
          "few": "Papua Naujosios Gvinėjos kinos",
          "many": "Papua Naujosios Gvinėjos kinos",
          "one": "Papua Naujosios Gvinėjos kina",
          "other": "Papua Naujosios Gvinėjos kinų"
        },
        "narrow": "PGK",
        "symbol": "PGK"
      },
      "PHP": {
        "displayName": {
          "few": "Filipinų pesai",
          "many": "Filipinų peso",
          "one": "Filipinų pesas",
          "other": "Filipinų pesų"
        },
        "narrow": "₱",
        "symbol": "PHP"
      },
      "PKR": {
        "displayName": {
          "few": "Pakistano rupijos",
          "many": "Pakistano rupijos",
          "one": "Pakistano rupija",
          "other": "Pakistano rupijų"
        },
        "narrow": "Rs",
        "symbol": "PKR"
      },
      "PLN": {
        "displayName": {
          "few": "Lenkijos zlotai",
          "many": "Lenkijos zloto",
          "one": "Lenkijos zlotas",
          "other": "Lenkijos zlotų"
        },
        "narrow": "zl",
        "symbol": "PLN"
      },
      "PLZ": {
        "displayName": {
          "few": "Lenkijos zlotai (1950–1995)",
          "many": "Lenkijos zloto (1950–1995)",
          "one": "Lenkijos zlotas (1950–1995)",
          "other": "Lenkijos zlotų (1950–1995)"
        },
        "narrow": "PLZ",
        "symbol": "PLZ"
      },
      "PTE": {
        "displayName": {
          "few": "Portugalijos eskudai",
          "many": "Portugalijos eskudo",
          "one": "Portugalijos eskudas",
          "other": "Portugalijos eskudų"
        },
        "narrow": "PTE",
        "symbol": "PTE"
      },
      "PYG": {
        "displayName": {
          "few": "Paragvajaus guaraniai",
          "many": "Paragvajaus guaranio",
          "one": "Paragvajaus guaranis",
          "other": "Paragvajaus guaranių"
        },
        "narrow": "Gs",
        "symbol": "PYG"
      },
      "QAR": {
        "displayName": {
          "few": "Kataro rialai",
          "many": "Kataro rialo",
          "one": "Kataro rialas",
          "other": "Kataro rialų"
        },
        "narrow": "QAR",
        "symbol": "QAR"
      },
      "RHD": {
        "displayName": {
          "few": "Rodezijos doleriai",
          "many": "Rodezijos dolerio",
          "one": "Rodezijos doleris",
          "other": "Rodezijos dolerių"
        },
        "narrow": "RHD",
        "symbol": "RHD"
      },
      "ROL": {
        "displayName": {
          "few": "Rumunijos lėjos (1952–2006)",
          "many": "Rumunijos lėjos (1952–2006)",
          "one": "Rumunijos lėja (1952–2006)",
          "other": "Rumunijos lėjų (1952–2006)"
        },
        "narrow": "ROL",
        "symbol": "ROL"
      },
      "RON": {
        "displayName": {
          "few": "Rumunijos lėjos",
          "many": "Rumunijos lėjos",
          "one": "Rumunijos lėja",
          "other": "Rumunijos lėjų"
        },
        "narrow": "lei",
        "symbol": "RON"
      },
      "RSD": {
        "displayName": {
          "few": "Serbijos dinarai",
          "many": "Serbijos dinaro",
          "one": "Serbijos dinaras",
          "other": "Serbijos dinarų"
        },
        "narrow": "RSD",
        "symbol": "RSD"
      },
      "RUB": {
        "displayName": {
          "few": "Rusijos rubliai",
          "many": "Rusijos rublio",
          "one": "Rusijos rublis",
          "other": "Rusijos rublių"
        },
        "narrow": "rb",
        "symbol": "RUB"
      },
      "RUR": {
        "displayName": {
          "few": "Rusijos rubliai (1991–1998)",
          "many": "Rusijos rublio (1991–1998)",
          "one": "Rusijos rublis (1991–1998)",
          "other": "Rusijos rublių (1991–1998)"
        },
        "narrow": "RUR",
        "symbol": "RUR"
      },
      "RWF": {
        "displayName": {
          "few": "Ruandos frankai",
          "many": "Ruandos franko",
          "one": "Ruandos frankas",
          "other": "Ruandos frankų"
        },
        "narrow": "RF",
        "symbol": "RWF"
      },
      "SAR": {
        "displayName": {
          "few": "Saudo Arabijos rijalai",
          "many": "Saudo Arabijos rijalo",
          "one": "Saudo Arabijos rijalas",
          "other": "Saudo Arabijos rijalų"
        },
        "narrow": "SAR",
        "symbol": "SAR"
      },
      "SBD": {
        "displayName": {
          "few": "Saliamono salų doleriai",
          "many": "Saliamono salų dolerio",
          "one": "Saliamono salų doleris",
          "other": "Saliamono salų dolerių"
        },
        "narrow": "$",
        "symbol": "SBD"
      },
      "SCR": {
        "displayName": {
          "few": "Seišelių rupijos",
          "many": "Seišelių rupijos",
          "one": "Seišelių rupija",
          "other": "Seišelių rupijų"
        },
        "narrow": "SCR",
        "symbol": "SCR"
      },
      "SDD": {
        "displayName": {
          "few": "Sudano dinarai (1992–2007)",
          "many": "Sudano dinaro (1992–2007)",
          "one": "Sudano dinaras (1992–2007)",
          "other": "Sudano dinarų (1992–2007)"
        },
        "narrow": "SDD",
        "symbol": "SDD"
      },
      "SDG": {
        "displayName": {
          "few": "Sudano svarai",
          "many": "Sudano svaro",
          "one": "Sudano svaras",
          "other": "Sudano svarų"
        },
        "narrow": "SDG",
        "symbol": "SDG"
      },
      "SDP": {
        "displayName": {
          "few": "Sudano svarai (1957–1998)",
          "many": "Sudano svaro (1957–1998)",
          "one": "Sudano svaras (1957–1998)",
          "other": "Sudano svarų (1957–1998)"
        },
        "narrow": "SDP",
        "symbol": "SDP"
      },
      "SEK": {
        "displayName": {
          "few": "Švedijos kronos",
          "many": "Švedijos kronos",
          "one": "Švedijos krona",
          "other": "Švedijos kronų"
        },
        "narrow": "kr",
        "symbol": "SEK"
      },
      "SGD": {
        "displayName": {
          "few": "Singapūro doleriai",
          "many": "Singapūro dolerio",
          "one": "Singapūro doleris",
          "other": "Singapūro dolerių"
        },
        "narrow": "$",
        "symbol": "SGD"
      },
      "SHP": {
        "displayName": {
          "few": "Šv. Elenos salų svarai",
          "many": "Šv. Elenos salų svaro",
          "one": "Šv. Elenos salų svaras",
          "other": "Šv. Elenos salų svarų"
        },
        "narrow": "£",
        "symbol": "SHP"
      },
      "SIT": {
        "displayName": {
          "few": "Slovėnijos tolars",
          "one": "Slovėnijos tolars",
          "other": "Slovėnijos tolar"
        },
        "narrow": "SIT",
        "symbol": "SIT"
      },
      "SKK": {
        "displayName": {
          "few": "Slovakijos kronos",
          "many": "Slovakijos kronos",
          "one": "Slovakijos krona",
          "other": "Slovakijos kronų"
        },
        "narrow": "SKK",
        "symbol": "SKK"
      },
      "SLL": {
        "displayName": {
          "few": "Siera Leonės leonės",
          "many": "Siera Leonės leonės",
          "one": "Siera Leonės leonė",
          "other": "Siera Leonės leonių"
        },
        "narrow": "SLL",
        "symbol": "SLL"
      },
      "SOS": {
        "displayName": {
          "few": "Somalio šilingai",
          "many": "Somalio šilingo",
          "one": "Somalio šilingas",
          "other": "Somalio šilingų"
        },
        "narrow": "SOS",
        "symbol": "SOS"
      },
      "SRD": {
        "displayName": {
          "few": "Surimano doleriai",
          "many": "Surimano dolerio",
          "one": "Surimano doleris",
          "other": "Surimano dolerių"
        },
        "narrow": "$",
        "symbol": "SRD"
      },
      "SRG": {
        "displayName": {
          "few": "Surimano guldenai",
          "many": "Surimano guldeno",
          "one": "Surimano guldenas",
          "other": "Surimano guldenų"
        },
        "narrow": "SRG",
        "symbol": "SRG"
      },
      "SSP": {
        "displayName": {
          "few": "Pietų Sudano svarai",
          "many": "Pietų Sudano svaro",
          "one": "Pietų Sudano svaras",
          "other": "Pietų Sudano svarų"
        },
        "narrow": "£",
        "symbol": "SSP"
      },
      "STD": {
        "displayName": {
          "few": "San Tomės ir Principės dobros (1977–2017)",
          "many": "San Tomės ir Principės dobros (1977–2017)",
          "one": "San Tomės ir Principės dobra (1977–2017)",
          "other": "Sao Tomės ir Principės dobrų (1977–2017)"
        },
        "narrow": "STD",
        "symbol": "STD"
      },
      "STN": {
        "displayName": {
          "few": "San Tomės ir Principės dobros",
          "many": "San Tomės ir Principės dobros",
          "one": "San Tomės ir Principės dobra",
          "other": "Sao Tomės ir Principės dobrų"
        },
        "narrow": "Db",
        "symbol": "STN"
      },
      "SUR": {
        "displayName": {
          "few": "Sovietų rubliai",
          "many": "Sovietų rublio",
          "one": "Sovietų rublis",
          "other": "Sovietų rublių"
        },
        "narrow": "SUR",
        "symbol": "SUR"
      },
      "SVC": {
        "displayName": {
          "one": "Salvadoro kolonas",
          "other": "Salvadoro kolonai"
        },
        "narrow": "SVC",
        "symbol": "SVC"
      },
      "SYP": {
        "displayName": {
          "few": "Sirijos svarai",
          "many": "Sirijos svaro",
          "one": "Sirijos svaras",
          "other": "Sirijos svarų"
        },
        "narrow": "£",
        "symbol": "SYP"
      },
      "SZL": {
        "displayName": {
          "few": "Svazilando lilangeniai",
          "many": "Svazilendo lilangenio",
          "one": "Svazilando lilangenis",
          "other": "Svazilendo lilangenių"
        },
        "narrow": "SZL",
        "symbol": "SZL"
      },
      "THB": {
        "displayName": {
          "few": "Tailando batai",
          "many": "Tailando bato",
          "one": "Tailando batas",
          "other": "Tailando batų"
        },
        "narrow": "฿",
        "symbol": "THB"
      },
      "TJR": {
        "displayName": {
          "few": "Tadžikistano rubliai",
          "many": "Tadžikistano rublio",
          "one": "Tadžikistano rublis",
          "other": "Tadžikistano rublių"
        },
        "narrow": "TJR",
        "symbol": "TJR"
      },
      "TJS": {
        "displayName": {
          "few": "Tadžikistano somoniai",
          "many": "Tadžikistano somonio",
          "one": "Tadžikistano somonis",
          "other": "Tadžikistano somonių"
        },
        "narrow": "TJS",
        "symbol": "TJS"
      },
      "TMM": {
        "displayName": {
          "few": "Turkmėnistano manatai (1993–2009)",
          "many": "Turkmėnistano manato (1993–2009)",
          "one": "Turkmėnistano manatas (1993–2009)",
          "other": "Turkmėnistano manatų (1993–2009)"
        },
        "narrow": "TMM",
        "symbol": "TMM"
      },
      "TMT": {
        "displayName": {
          "few": "Turkmėnistano manatai",
          "many": "Turkmėnistano manato",
          "one": "Turkmėnistano manatas",
          "other": "Turkmėnistano manatų"
        },
        "narrow": "TMT",
        "symbol": "TMT"
      },
      "TND": {
        "displayName": {
          "few": "Tuniso dinarai",
          "many": "Tuniso dinaro",
          "one": "Tuniso dinaras",
          "other": "Tuniso dinarų"
        },
        "narrow": "TND",
        "symbol": "TND"
      },
      "TOP": {
        "displayName": {
          "few": "Tongo paangos",
          "many": "Tongo paangos",
          "one": "Tongo paanga",
          "other": "Tongo paangų"
        },
        "narrow": "T$",
        "symbol": "TOP"
      },
      "TPE": {
        "displayName": {
          "few": "Timoro eskudai",
          "many": "Timoro eskudo",
          "one": "Timoro eskudas",
          "other": "Timoro eskudų"
        },
        "narrow": "TPE",
        "symbol": "TPE"
      },
      "TRL": {
        "displayName": {
          "few": "Turkijos liros (1922–2005)",
          "many": "Turkijos liros (1922–2005)",
          "one": "Turkijos lira (1922–2005)",
          "other": "Turkijos lirų (1922–2005)"
        },
        "narrow": "TRL",
        "symbol": "TRL"
      },
      "TRY": {
        "displayName": {
          "few": "Turkijos liros",
          "many": "Turkijos liros",
          "one": "Turkijos lira",
          "other": "Turkijos lirų"
        },
        "narrow": "₺",
        "symbol": "TRY"
      },
      "TTD": {
        "displayName": {
          "few": "Trinidado ir Tobago doleriai",
          "many": "Trinidado ir Tobago dolerio",
          "one": "Trinidado ir Tobago doleris",
          "other": "Trinidado ir Tobago dolerių"
        },
        "narrow": "$",
        "symbol": "TTD"
      },
      "TWD": {
        "displayName": {
          "few": "Taivano naujieji doleriai",
          "many": "Taivano naujojo dolerio",
          "one": "Taivano naujasis doleris",
          "other": "Taivano naujųjų dolerių"
        },
        "narrow": "$",
        "symbol": "TWD"
      },
      "TZS": {
        "displayName": {
          "few": "Tanzanijos šilingai",
          "many": "Tanzanijos šilingo",
          "one": "Tanzanijos šilingas",
          "other": "Tanzanijos šilingų"
        },
        "narrow": "TZS",
        "symbol": "TZS"
      },
      "UAH": {
        "displayName": {
          "few": "Ukrainos grivinos",
          "many": "Ukrainos grivinos",
          "one": "Ukrainos grivina",
          "other": "Ukrainos grivinų"
        },
        "narrow": "₴",
        "symbol": "UAH"
      },
      "UAK": {
        "displayName": {
          "one": "Ukrainos karbovanets",
          "other": "Ukrainos karbovantsiv"
        },
        "narrow": "UAK",
        "symbol": "UAK"
      },
      "UGS": {
        "displayName": {
          "few": "Ugandos šilingai (1966–1987)",
          "many": "Ugandos šilingo (1966–1987)",
          "one": "Ugandos šilingas (1966–1987)",
          "other": "Ugandos šilingų (1966–1987)"
        },
        "narrow": "UGS",
        "symbol": "UGS"
      },
      "UGX": {
        "displayName": {
          "few": "Ugandos šilingai",
          "many": "Ugandos šilingo",
          "one": "Ugandos šilingas",
          "other": "Ugandos šilingų"
        },
        "narrow": "UGX",
        "symbol": "UGX"
      },
      "USD": {
        "displayName": {
          "few": "JAV doleriai",
          "many": "JAV dolerio",
          "one": "JAV doleris",
          "other": "JAV dolerių"
        },
        "narrow": "$",
        "symbol": "USD"
      },
      "USN": {
        "displayName": {
          "few": "JAV doleriai (kitą dieną)",
          "many": "JAV dolerio (kitą dieną)",
          "one": "JAV doleris (kitą dieną)",
          "other": "JAV dolerių (kitą dieną)"
        },
        "narrow": "USN",
        "symbol": "USN"
      },
      "USS": {
        "displayName": {
          "few": "JAV doleriai (tą pačią dieną)",
          "many": "JAV dolerio (tą pačią dieną)",
          "one": "JAV doleris (tą pačią dieną)",
          "other": "JAV dolerių (tą pačią dieną)"
        },
        "narrow": "USS",
        "symbol": "USS"
      },
      "UYI": {
        "displayName": {
          "few": "Uragvajaus pesai en unidades indexadas",
          "one": "Urugvajaus pesas en unidades indexadas",
          "other": "Urugvajaus pesai en unidades indexadas"
        },
        "narrow": "UYI",
        "symbol": "UYI"
      },
      "UYP": {
        "displayName": {
          "few": "Urugvajaus pesai (1975–1993)",
          "many": "Urugvajaus peso (1975–1993)",
          "one": "Urugvajaus pesas (1975–1993)",
          "other": "Urugvajaus pesų (1975–1993)"
        },
        "narrow": "UYP",
        "symbol": "UYP"
      },
      "UYU": {
        "displayName": {
          "few": "Urugvajaus pesai",
          "many": "Urugvajaus peso",
          "one": "Urugvajaus pesas",
          "other": "Urugvajaus pesų"
        },
        "narrow": "$",
        "symbol": "UYU"
      },
      "UZS": {
        "displayName": {
          "few": "Uzbekistano sumai",
          "many": "Uzbekistano sumo",
          "one": "Uzbekistano sumas",
          "other": "Uzbekistano sumų"
        },
        "narrow": "UZS",
        "symbol": "UZS"
      },
      "VEB": {
        "displayName": {
          "few": "Venesuelos bolivarai (1871–2008)",
          "many": "Venesuelos bolivaro (1871–2008)",
          "one": "Venesuelos bolivaras (1871–2008)",
          "other": "Venesuelos bolivarų (1871–2008)"
        },
        "narrow": "VEB",
        "symbol": "VEB"
      },
      "VEF": {
        "displayName": {
          "few": "Venesuelos bolivarai (2008–2018)",
          "many": "Venesuelos bolivaro (2008–2018)",
          "one": "Venesuelos bolivaras (2008–2018)",
          "other": "Venesuelos bolivarų (2008–2018)"
        },
        "narrow": "Bs",
        "symbol": "VEF"
      },
      "VES": {
        "displayName": {
          "few": "Venesuelos bolivarai",
          "many": "Venesuelos bolivaro",
          "one": "Venesuelos bolivaras",
          "other": "Venesuelos bolivarų"
        },
        "narrow": "VES",
        "symbol": "VES"
      },
      "VND": {
        "displayName": {
          "few": "Vietnamo dongai",
          "many": "Vietnamo dongo",
          "one": "Vietnamo dongas",
          "other": "Vietnamo dongų"
        },
        "narrow": "VND",
        "symbol": "VND"
      },
      "VNN": {
        "displayName": {
          "few": "Vietnamo dongai (1978–1985)",
          "many": "Vietnamo dongo (1978–1985)",
          "one": "Vietnamo dongas (1978–1985)",
          "other": "Vietnamo dongų (1978–1985)"
        },
        "narrow": "VNN",
        "symbol": "VNN"
      },
      "VUV": {
        "displayName": {
          "few": "Vanuatu vatai",
          "many": "Vanuatu vato",
          "one": "Vanuatu vatas",
          "other": "Vanuatu vatų"
        },
        "narrow": "VUV",
        "symbol": "VUV"
      },
      "WST": {
        "displayName": {
          "few": "Samoa talos",
          "many": "Samoa talos",
          "one": "Samoa tala",
          "other": "Samoa talų"
        },
        "narrow": "WST",
        "symbol": "WST"
      },
      "XAF": {
        "displayName": {
          "few": "CFA BEAC frankai",
          "many": "CFA BEAC franko",
          "one": "CFA BEAC frankas",
          "other": "CFA BEAC frankų"
        },
        "narrow": "XAF",
        "symbol": "XAF"
      },
      "XAG": {
        "displayName": {
          "other": "Sidabras"
        },
        "narrow": "XAG",
        "symbol": "XAG"
      },
      "XAU": {
        "displayName": {
          "other": "Auksas"
        },
        "narrow": "XAU",
        "symbol": "XAU"
      },
      "XBA": {
        "displayName": {
          "one": "Europos suvestinės vienetas",
          "other": "Europos suvestinės vienetai"
        },
        "narrow": "XBA",
        "symbol": "XBA"
      },
      "XBB": {
        "displayName": {
          "one": "Europos piniginis vienetas",
          "other": "Europos piniginiai vienetai"
        },
        "narrow": "XBB",
        "symbol": "XBB"
      },
      "XBC": {
        "displayName": {
          "one": "Europos valiutos / apskaitos vienetas (XBC)",
          "other": "Europos valiutos / apskaitos vienetai (XBC)"
        },
        "narrow": "XBC",
        "symbol": "XBC"
      },
      "XBD": {
        "displayName": {
          "few": "Europos valiutos / apskaitos vienetas (XBD)",
          "one": "Europos valiutos / apskaitos vienetas (XBD)",
          "other": "Europos valiutos / apskaitos vienetai (XBD)"
        },
        "narrow": "XBD",
        "symbol": "XBD"
      },
      "XCD": {
        "displayName": {
          "few": "Rytų Karibų doleriai",
          "many": "Rytų Karibų dolerio",
          "one": "Rytų Karibų doleris",
          "other": "Rytų Karibų dolerių"
        },
        "narrow": "$",
        "symbol": "XCD"
      },
      "XDR": {
        "displayName": {
          "other": "SDR tarptautinis valiutos fondas"
        },
        "narrow": "XDR",
        "symbol": "XDR"
      },
      "XEU": {
        "displayName": {
          "other": "Europos piniginis vienetas (1993–1999)"
        },
        "narrow": "XEU",
        "symbol": "XEU"
      },
      "XFO": {
        "displayName": {
          "few": "Aukso frankai",
          "many": "Aukso franko",
          "one": "Aukso frankas",
          "other": "Aukso frankų"
        },
        "narrow": "XFO",
        "symbol": "XFO"
      },
      "XFU": {
        "displayName": {
          "few": "Prancūzijos UIC - frankai",
          "many": "Prancūzijos UIC - franko",
          "one": "Prancūzijos UIC - frankas",
          "other": "Prancūzijos UIC - frankų"
        },
        "narrow": "XFU",
        "symbol": "XFU"
      },
      "XOF": {
        "displayName": {
          "few": "CFA BCEAO frankai",
          "many": "CFA BCEAO franko",
          "one": "CFA BCEAO frankas",
          "other": "CFA BCEAO frankų"
        },
        "narrow": "XOF",
        "symbol": "XOF"
      },
      "XPD": {
        "displayName": {
          "other": "Paladis"
        },
        "narrow": "XPD",
        "symbol": "XPD"
      },
      "XPF": {
        "displayName": {
          "few": "CFP frankai",
          "many": "CFP franko",
          "one": "CFP frankas",
          "other": "CFP frankų"
        },
        "narrow": "XPF",
        "symbol": "XPF"
      },
      "XPT": {
        "displayName": {
          "other": "Platina"
        },
        "narrow": "XPT",
        "symbol": "XPT"
      },
      "XRE": {
        "displayName": {
          "one": "RINET fondas",
          "other": "RINET fondai"
        },
        "narrow": "XRE",
        "symbol": "XRE"
      },
      "XSU": {
        "displayName": {
          "few": "Sukrės",
          "many": "Sukrės",
          "one": "Sukrė",
          "other": "Sukrių"
        },
        "narrow": "XSU",
        "symbol": "XSU"
      },
      "XTS": {
        "displayName": {
          "other": "Tikrinamas valiutos kodas"
        },
        "narrow": "XTS",
        "symbol": "XTS"
      },
      "XUA": {
        "displayName": {
          "few": "Azijos plėtros banko apskaitos vienetai",
          "many": "Azijos plėtros banko apskaitos vieneto",
          "one": "Azijos plėtros banko apskaitos vienetas",
          "other": "Azijos plėtros banko apskaitos vienetų"
        },
        "narrow": "XUA",
        "symbol": "XUA"
      },
      "XXX": {
        "displayName": {
          "other": "(nežinoma valiuta)"
        },
        "narrow": "¤",
        "symbol": "¤"
      },
      "YDD": {
        "displayName": {
          "few": "Jemeno dinarai",
          "many": "Jemeno dinaro",
          "one": "Jemeno dinaras",
          "other": "Jemeno dinarų"
        },
        "narrow": "YDD",
        "symbol": "YDD"
      },
      "YER": {
        "displayName": {
          "few": "Jemeno rialai",
          "many": "Jemeno rialo",
          "one": "Jemeno rialas",
          "other": "Jemeno rialų"
        },
        "narrow": "YER",
        "symbol": "YER"
      },
      "YUD": {
        "displayName": {
          "few": "Jugoslavijos kietieji dinarai (1966–1990)",
          "many": "Jugoslavijos kietiejo dinaro (1966–1990)",
          "one": "Jugoslavijos kietasis dinaras (1966–1990)",
          "other": "Jugoslavijos kietiejų dinarų (1966–1990)"
        },
        "narrow": "YUD",
        "symbol": "YUD"
      },
      "YUM": {
        "displayName": {
          "few": "Jugoslavijos naujieji dinarai (1994–2002)",
          "many": "Jugoslavijos naujojo dinaro (1994–2002)",
          "one": "Jugoslavijos naujasis dinaras (1994–2002)",
          "other": "Jugoslavijos naujųjų dinarų (1994–2002)"
        },
        "narrow": "YUM",
        "symbol": "YUM"
      },
      "YUN": {
        "displayName": {
          "few": "Jugoslavijos konvertuojami dinarai (1990–1992)",
          "many": "Jugoslavijos konvertuojamo dinaro (1990–1992)",
          "one": "Jugoslavijos konvertuojamas dinaras (1990–1992)",
          "other": "Jugoslavijos konvertuojamų dinarų (1990–1992)"
        },
        "narrow": "YUN",
        "symbol": "YUN"
      },
      "YUR": {
        "displayName": {
          "few": "Jugoslavijos reformuoti dinarai (1992–1993)",
          "many": "Jugoslavijos reformuoto dinaro (1992–1993)",
          "one": "Jugoslavijos reformuotas dinaras (1992–1993)",
          "other": "Jugoslavijos reformuotų dinarų (1992–1993)"
        },
        "narrow": "YUR",
        "symbol": "YUR"
      },
      "ZAL": {
        "displayName": {
          "few": "Pietų Afrikos randai (finansinis)",
          "many": "Pietų Afrikos rando (finansinis)",
          "one": "Pietų Afrikos randas (finansinis)",
          "other": "Pietų Afrikos randų (finansinis)"
        },
        "narrow": "ZAL",
        "symbol": "ZAL"
      },
      "ZAR": {
        "displayName": {
          "few": "Pietų Afrikos Respublikos randai",
          "many": "Pietų Afrikos Respublikos rando",
          "one": "Pietų Afrikos Respublikos randas",
          "other": "Pietų Afrikos Respublikos randų"
        },
        "narrow": "R",
        "symbol": "ZAR"
      },
      "ZMK": {
        "displayName": {
          "few": "Zambijos kvačos (1968–2012)",
          "many": "Zambijos kvačos (1968–2012)",
          "one": "Zambijos kvača (1968–2012)",
          "other": "Zambijos kvačų (1968–2012)"
        },
        "narrow": "ZMK",
        "symbol": "ZMK"
      },
      "ZMW": {
        "displayName": {
          "few": "Zambijos kvačos",
          "many": "Zambijos kvačos",
          "one": "Zambijos kvača",
          "other": "Zambijos kvačų"
        },
        "narrow": "ZK",
        "symbol": "ZMW"
      },
      "ZRN": {
        "displayName": {
          "few": "Zairo naujieji zairai (1993–1998)",
          "many": "Zairo naujojo zairo (1993–1998)",
          "one": "Zairo naujasis zairas (1993–1998)",
          "other": "Zairo naujųjų zairų (1993–1998)"
        },
        "narrow": "ZRN",
        "symbol": "ZRN"
      },
      "ZRZ": {
        "displayName": {
          "few": "Zairo zairai (1971–1993)",
          "many": "Zairo zairo (1971–1993)",
          "one": "Zairo zairas (1971–1993)",
          "other": "Zairo zairų (1971–1993)"
        },
        "narrow": "ZRZ",
        "symbol": "ZRZ"
      },
      "ZWD": {
        "displayName": {
          "few": "Zimbabvės doleriai (1980–2008)",
          "many": "Zimbabvės dolerio (1980–2008)",
          "one": "Zimbabvės doleris (1980–2008)",
          "other": "Zimbabvės dolerių (1980–2008)"
        },
        "narrow": "ZWD",
        "symbol": "ZWD"
      },
      "ZWL": {
        "displayName": {
          "few": "Zimbabvės doleriai (2009)",
          "many": "Zimbabvės dolerio (2009)",
          "one": "Zimbabvės doleris (2009)",
          "other": "Zimbabvės dolerių (2009)"
        },
        "narrow": "ZWL",
        "symbol": "ZWL"
      },
      "ZWR": {
        "displayName": {
          "few": "Zimbabvės doleriai (2008)",
          "many": "Zimbabvės dolerio (2008)",
          "one": "Zimbabvės doleris (2008)",
          "other": "Zimbabvės dolerių (2008)"
        },
        "narrow": "ZWR",
        "symbol": "ZWR"
      }
    },
    "nu": [
      "latn"
    ],
    "numbers": {
      "currency": {
        "latn": {
          "accounting": "#,##0.00 ¤",
          "currencySpacing": {
            "afterInsertBetween": " ",
            "beforeInsertBetween": " "
          },
          "short": {
            "1000": {
              "other": "0 tūkst'.' ¤"
            },
            "10000": {
              "other": "00 tūkst'.' ¤"
            },
            "100000": {
              "other": "000 tūkst'.' ¤"
            },
            "1000000": {
              "other": "0 mln'.' ¤"
            },
            "10000000": {
              "other": "00 mln'.' ¤"
            },
            "100000000": {
              "other": "000 mln'.' ¤"
            },
            "1000000000": {
              "other": "0 mlrd'.' ¤"
            },
            "10000000000": {
              "other": "00 mlrd'.' ¤"
            },
            "100000000000": {
              "other": "000 mlrd'.' ¤"
            },
            "1000000000000": {
              "other": "0 trln'.' ¤"
            },
            "10000000000000": {
              "other": "00 trln'.' ¤"
            },
            "100000000000000": {
              "other": "000 trln'.' ¤"
            }
          },
          "standard": "#,##0.00 ¤",
          "unitPattern": "{0} {1}"
        }
      },
      "decimal": {
        "latn": {
          "long": {
            "1000": {
              "few": "0 tūkstančiai",
              "many": "0 tūkstančio",
              "one": "0 tūkstantis",
              "other": "0 tūkstančių"
            },
            "10000": {
              "few": "00 tūkstančiai",
              "many": "00 tūkstančio",
              "one": "00 tūkstantis",
              "other": "00 tūkstančių"
            },
            "100000": {
              "few": "000 tūkstančiai",
              "many": "000 tūkstančio",
              "one": "000 tūkstantis",
              "other": "000 tūkstančių"
            },
            "1000000": {
              "few": "0 milijonai",
              "many": "0 milijono",
              "one": "0 milijonas",
              "other": "0 milijonų"
            },
            "10000000": {
              "few": "00 milijonai",
              "many": "00 milijono",
              "one": "00 milijonas",
              "other": "00 milijonų"
            },
            "100000000": {
              "few": "000 milijonai",
              "many": "000 milijono",
              "one": "000 milijonas",
              "other": "000 milijonų"
            },
            "1000000000": {
              "few": "0 milijardai",
              "many": "0 milijardo",
              "one": "0 milijardas",
              "other": "0 milijardų"
            },
            "10000000000": {
              "few": "00 milijardai",
              "many": "00 milijardo",
              "one": "00 milijardas",
              "other": "00 milijardų"
            },
            "100000000000": {
              "few": "000 milijardai",
              "many": "000 milijardo",
              "one": "000 milijardas",
              "other": "000 milijardų"
            },
            "1000000000000": {
              "few": "0 trilijonai",
              "many": "0 trilijono",
              "one": "0 trilijonas",
              "other": "0 trilijonų"
            },
            "10000000000000": {
              "few": "00 trilijonai",
              "many": "00 trilijono",
              "one": "00 trilijonas",
              "other": "00 trilijonų"
            },
            "100000000000000": {
              "few": "000 trilijonai",
              "many": "000 trilijono",
              "one": "000 trilijonas",
              "other": "000 trilijonų"
            }
          },
          "short": {
            "1000": {
              "other": "0 tūkst'.'"
            },
            "10000": {
              "other": "00 tūkst'.'"
            },
            "100000": {
              "other": "000 tūkst'.'"
            },
            "1000000": {
              "other": "0 mln'.'"
            },
            "10000000": {
              "other": "00 mln'.'"
            },
            "100000000": {
              "other": "000 mln'.'"
            },
            "1000000000": {
              "other": "0 mlrd'.'"
            },
            "10000000000": {
              "other": "00 mlrd'.'"
            },
            "100000000000": {
              "other": "000 mlrd'.'"
            },
            "1000000000000": {
              "other": "0 trln'.'"
            },
            "10000000000000": {
              "other": "00 trln'.'"
            },
            "100000000000000": {
              "other": "000 trln'.'"
            }
          },
          "standard": "#,##0.###"
        }
      },
      "nu": [
        "latn"
      ],
      "percent": {
        "latn": "#,##0 %"
      },
      "symbols": {
        "latn": {
          "approximatelySign": "∼",
          "decimal": ",",
          "exponential": "×10^",
          "group": " ",
          "infinity": "∞",
          "list": ";",
          "minusSign": "−",
          "nan": "NaN",
          "perMille": "‰",
          "percentSign": "%",
          "plusSign": "+",
          "rangeSign": "–",
          "superscriptingExponent": "×",
          "timeSeparator": ":"
        }
      }
    },
    "units": {
      "compound": {
        "per": {
          "long": "{0}/{1}",
          "narrow": "{0}/{1}",
          "short": "{0}/{1}"
        }
      },
      "simple": {
        "acre": {
          "long": {
            "few": "{0} akrai",
            "many": "{0} akro",
            "one": "{0} akras",
            "other": "{0} akrų"
          },
          "narrow": {
            "other": "{0} ak"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} akr."
          }
        },
        "bit": {
          "long": {
            "few": "{0} bitai",
            "many": "{0} bito",
            "one": "{0} bitas",
            "other": "{0} bitų"
          },
          "narrow": {
            "other": "{0} b"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} b"
          }
        },
        "byte": {
          "long": {
            "few": "{0} baitai",
            "many": "{0} baito",
            "one": "{0} baitas",
            "other": "{0} baitų"
          },
          "narrow": {
            "other": "{0} B"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} B"
          }
        },
        "celsius": {
          "long": {
            "few": "{0} Celsijaus laipsniai",
            "many": "{0} Celsijaus laipsnio",
            "one": "{0} Celsijaus laipsnis",
            "other": "{0} Celsijaus laipsnių"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°C"
          }
        },
        "centimeter": {
          "long": {
            "few": "{0} centimetrai",
            "many": "{0} centimetro",
            "one": "{0} centimetras",
            "other": "{0} centimetrų"
          },
          "narrow": {
            "other": "{0} cm"
          },
          "perUnit": {
            "long": "{0}/cm",
            "narrow": "{0}/cm",
            "short": "{0}/cm"
          },
          "short": {
            "other": "{0} cm"
          }
        },
        "day": {
          "long": {
            "few": "{0} dienos",
            "many": "{0} dienos",
            "one": "{0} diena",
            "other": "{0} dienų"
          },
          "narrow": {
            "other": "{0} d."
          },
          "perUnit": {
            "long": "{0} per dieną",
            "narrow": "{0}/d.",
            "short": "{0}/d."
          },
          "short": {
            "other": "{0} d."
          }
        },
        "degree": {
          "long": {
            "few": "{0} laipsniai",
            "many": "{0} laipsnio",
            "one": "{0} laipsnis",
            "other": "{0} laipsnių"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°"
          }
        },
        "fahrenheit": {
          "long": {
            "few": "{0} Farenheito laipsniai",
            "many": "{0} Farenheito laipsnio",
            "one": "{0} Farenheito laipsnis",
            "other": "{0} Farenheito laipsnių"
          },
          "narrow": {
            "other": "{0}°F"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°F"
          }
        },
        "fluid-ounce": {
          "long": {
            "few": "{0} skysčio uncijos",
            "many": "{0} skysčio uncijos",
            "one": "{0} skysčio uncija",
            "other": "{0} skysčio uncijų"
          },
          "narrow": {
            "other": "{0} fl oz"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} skysčio oz"
          }
        },
        "foot": {
          "long": {
            "few": "{0} pėdos",
            "many": "{0} pėdos",
            "one": "{0} pėda",
            "other": "{0} pėdų"
          },
          "narrow": {
            "other": "{0} ft"
          },
          "perUnit": {
            "long": "{0}/ft",
            "narrow": "{0}/ft",
            "short": "{0}/ft"
          },
          "short": {
            "other": "{0} ft"
          }
        },
        "gallon": {
          "long": {
            "few": "{0} galonai",
            "many": "{0} galono",
            "one": "{0} galonas",
            "other": "{0} galonų"
          },
          "narrow": {
            "other": "{0} gal"
          },
          "perUnit": {
            "long": "{0}/gal",
            "narrow": "{0}/gal",
            "short": "{0}/gal"
          },
          "short": {
            "other": "{0} gal"
          }
        },
        "gigabit": {
          "long": {
            "few": "{0} gigabitai",
            "many": "{0} gigabito",
            "one": "{0} gigabitas",
            "other": "{0} gigabitų"
          },
          "narrow": {
            "other": "{0} Gb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Gb"
          }
        },
        "gigabyte": {
          "long": {
            "few": "{0} gigabaitai",
            "many": "{0} gigabaito",
            "one": "{0} gigabaitas",
            "other": "{0} gigabaitų"
          },
          "narrow": {
            "other": "{0} GB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} GB"
          }
        },
        "gram": {
          "long": {
            "few": "{0} gramai",
            "many": "{0} gramo",
            "one": "{0} gramas",
            "other": "{0} gramų"
          },
          "narrow": {
            "other": "{0} g"
          },
          "perUnit": {
            "long": "{0}/g",
            "narrow": "{0}/g",
            "short": "{0}/g"
          },
          "short": {
            "other": "{0} g"
          }
        },
        "hectare": {
          "long": {
            "few": "{0} hektarai",
            "many": "{0} hektaro",
            "one": "{0} hektaras",
            "other": "{0} hektarų"
          },
          "narrow": {
            "other": "{0} ha"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ha"
          }
        },
        "hour": {
          "long": {
            "few": "{0} valandos",
            "many": "{0} valandos",
            "one": "{0} valanda",
            "other": "{0} valandų"
          },
          "narrow": {
            "other": "{0} h"
          },
          "perUnit": {
            "long": "{0}/h",
            "narrow": "{0}/h",
            "short": "{0}/h"
          },
          "short": {
            "other": "{0} val."
          }
        },
        "inch": {
          "long": {
            "few": "{0} coliai",
            "many": "{0} colio",
            "one": "{0} colis",
            "other": "{0} colių"
          },
          "narrow": {
            "other": "{0} in"
          },
          "perUnit": {
            "long": "{0}/in",
            "narrow": "{0}/in",
            "short": "{0}/in"
          },
          "short": {
            "other": "{0} in"
          }
        },
        "kilobit": {
          "long": {
            "few": "{0} kilobitai",
            "many": "{0} kilobito",
            "one": "{0} kilobitas",
            "other": "{0} kilobitų"
          },
          "narrow": {
            "other": "{0} kb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kb"
          }
        },
        "kilobyte": {
          "long": {
            "few": "{0} kilobaitai",
            "many": "{0} kilobaito",
            "one": "{0} kilobaitas",
            "other": "{0} kilobaitų"
          },
          "narrow": {
            "other": "{0} kB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kB"
          }
        },
        "kilogram": {
          "long": {
            "few": "{0} kilogramai",
            "many": "{0} kilogramo",
            "one": "{0} kilogramas",
            "other": "{0} kilogramų"
          },
          "narrow": {
            "other": "{0} kg"
          },
          "perUnit": {
            "long": "{0}/kg",
            "narrow": "{0}/kg",
            "short": "{0}/kg"
          },
          "short": {
            "other": "{0} kg"
          }
        },
        "kilometer": {
          "long": {
            "few": "{0} kilometrai",
            "many": "{0} kilometro",
            "one": "{0} kilometras",
            "other": "{0} kilometrų"
          },
          "narrow": {
            "other": "{0} km"
          },
          "perUnit": {
            "long": "{0}/km",
            "narrow": "{0}/km",
            "short": "{0}/km"
          },
          "short": {
            "other": "{0} km"
          }
        },
        "kilometer-per-hour": {
          "long": {
            "few": "{0} kilometrai per valandą",
            "many": "{0} kilometro per valandą",
            "one": "{0} kilometras per valandą",
            "other": "{0} kilometrų per valandą"
          },
          "narrow": {
            "other": "{0} km/h"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} km/val."
          }
        },
        "liter": {
          "long": {
            "few": "{0} litrai",
            "many": "{0} litro",
            "one": "{0} litras",
            "other": "{0} litrų"
          },
          "narrow": {
            "other": "{0} l"
          },
          "perUnit": {
            "long": "{0}/l",
            "narrow": "{0}/l",
            "short": "{0}/l"
          },
          "short": {
            "other": "{0} l"
          }
        },
        "liter-per-kilometer": {
          "long": {
            "few": "{0} litrai kilometrui",
            "many": "{0} litro kilometrui",
            "one": "{0} litras kilometrui",
            "other": "{0} litrų kilometrui"
          },
          "narrow": {
            "other": "{0} l/km"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} l/km"
          }
        },
        "megabit": {
          "long": {
            "few": "{0} megabitai",
            "many": "{0} megabito",
            "one": "{0} megabitas",
            "other": "{0} megabitų"
          },
          "narrow": {
            "other": "{0} Mb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Mb"
          }
        },
        "megabyte": {
          "long": {
            "few": "{0} megabaitai",
            "many": "{0} megabaito",
            "one": "{0} megabaitas",
            "other": "{0} megabaitų"
          },
          "narrow": {
            "other": "{0} MB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} MB"
          }
        },
        "meter": {
          "long": {
            "few": "{0} metrai",
            "many": "{0} metro",
            "one": "{0} metras",
            "other": "{0} metrų"
          },
          "narrow": {
            "other": "{0} m"
          },
          "perUnit": {
            "long": "{0}/m",
            "narrow": "{0}/m",
            "short": "{0}/m"
          },
          "short": {
            "other": "{0} m"
          }
        },
        "meter-per-second": {
          "long": {
            "few": "{0} metrai per sekundę",
            "many": "{0} metro per sekundę",
            "one": "{0} metras per sekundę",
            "other": "{0} metrų per sekundę"
          },
          "narrow": {
            "other": "{0} m/s"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} m/sek."
          }
        },
        "mile": {
          "long": {
            "few": "{0} mylios",
            "many": "{0} mylios",
            "one": "{0} mylia",
            "other": "{0} mylių"
          },
          "narrow": {
            "other": "{0} mi"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mi"
          }
        },
        "mile-per-gallon": {
          "long": {
            "few": "{0} mylios už galoną",
            "many": "{0} mylios už galoną",
            "one": "{0} mylia už galoną",
            "other": "{0} mylių už galoną"
          },
          "narrow": {
            "other": "{0} mi/gal"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} my/gal"
          }
        },
        "mile-per-hour": {
          "long": {
            "few": "{0} mylios per valandą",
            "many": "{0} mylios per valandą",
            "one": "{0} mylia per valandą",
            "other": "{0} mylių per valandą"
          },
          "narrow": {
            "other": "{0} mi/h"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mi/h"
          }
        },
        "mile-scandinavian": {
          "long": {
            "few": "{0} ilgosios mylios",
            "many": "{0} ilgosios mylios",
            "one": "{0} ilgoji mylia",
            "other": "{0} ilgųjų mylių"
          },
          "narrow": {
            "other": "{0} IM"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} IM"
          }
        },
        "milliliter": {
          "long": {
            "few": "{0} mililitrai",
            "many": "{0} mililitro",
            "one": "{0} mililitras",
            "other": "{0} mililitrų"
          },
          "narrow": {
            "other": "{0} ml"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ml"
          }
        },
        "millimeter": {
          "long": {
            "few": "{0} milimetrai",
            "many": "{0} milimetro",
            "one": "{0} milimetras",
            "other": "{0} milimetrų"
          },
          "narrow": {
            "other": "{0} mm"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mm"
          }
        },
        "millisecond": {
          "long": {
            "few": "{0} milisekundės",
            "many": "{0} milisekundės",
            "one": "{0} milisekundė",
            "other": "{0} milisekundžių"
          },
          "narrow": {
            "other": "{0} ms"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ms"
          }
        },
        "minute": {
          "long": {
            "few": "{0} minutės",
            "many": "{0} minutės",
            "one": "{0} minutė",
            "other": "{0} minučių"
          },
          "narrow": {
            "other": "{0} min."
          },
          "perUnit": {
            "long": "{0} per minutę",
            "narrow": "{0}/min.",
            "short": "{0}/min."
          },
          "short": {
            "other": "{0} min."
          }
        },
        "month": {
          "long": {
            "few": "{0} mėnesiai",
            "many": "{0} mėnesio",
            "one": "{0} mėnuo",
            "other": "{0} mėnesių"
          },
          "narrow": {
            "other": "{0} mėn."
          },
          "perUnit": {
            "long": "{0} per mėnesį",
            "narrow": "{0}/mėn.",
            "short": "{0}/mėn."
          },
          "short": {
            "other": "{0} mėn."
          }
        },
        "ounce": {
          "long": {
            "few": "{0} uncijos",
            "many": "{0} uncijos",
            "one": "{0} uncija",
            "other": "{0} uncijų"
          },
          "narrow": {
            "other": "{0} oz"
          },
          "perUnit": {
            "long": "{0}/oz",
            "narrow": "{0}/oz",
            "short": "{0}/oz"
          },
          "short": {
            "other": "{0} oz"
          }
        },
        "percent": {
          "long": {
            "few": "{0} procentai",
            "many": "{0} procento",
            "other": "{0} procentas"
          },
          "narrow": {
            "other": "{0} %"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} %"
          }
        },
        "petabyte": {
          "long": {
            "few": "{0} PB",
            "many": "{0} PB",
            "one": "{0} pentabaitas",
            "other": "{0} pentabaitų"
          },
          "narrow": {
            "other": "{0} PB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} PB"
          }
        },
        "pound": {
          "long": {
            "few": "{0} svarai",
            "many": "{0} svaro",
            "one": "{0} svaras",
            "other": "{0} svarų"
          },
          "narrow": {
            "other": "{0} lb"
          },
          "perUnit": {
            "long": "{0}/lb",
            "narrow": "{0}/lb",
            "short": "{0}/lb"
          },
          "short": {
            "other": "{0} lb"
          }
        },
        "second": {
          "long": {
            "few": "{0} sekundės",
            "many": "{0} sekundės",
            "one": "{0} sekundė",
            "other": "{0} sekundžių"
          },
          "narrow": {
            "other": "{0} s"
          },
          "perUnit": {
            "long": "{0}/s",
            "narrow": "{0}/s",
            "short": "{0}/s"
          },
          "short": {
            "other": "{0} sek."
          }
        },
        "stone": {
          "long": {
            "few": "{0} stonai",
            "many": "{0} stono",
            "one": "{0} stonas",
            "other": "{0} stonų"
          },
          "narrow": {
            "other": "{0} st"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} st"
          }
        },
        "terabit": {
          "long": {
            "few": "{0} terabitai",
            "many": "{0} terabito",
            "one": "{0} terabitas",
            "other": "{0} terabitų"
          },
          "narrow": {
            "other": "{0} Tb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Tb"
          }
        },
        "terabyte": {
          "long": {
            "few": "{0} terabaitai",
            "many": "{0} terabaito",
            "one": "{0} terabaitas",
            "other": "{0} terabaitų"
          },
          "narrow": {
            "other": "{0} TB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} TB"
          }
        },
        "week": {
          "long": {
            "few": "{0} savaitės",
            "many": "{0} savaitės",
            "one": "{0} savaitė",
            "other": "{0} savaičių"
          },
          "narrow": {
            "other": "{0} sav."
          },
          "perUnit": {
            "long": "{0} per savaitę",
            "narrow": "{0}/sav.",
            "short": "{0}/sav."
          },
          "short": {
            "other": "{0} sav."
          }
        },
        "yard": {
          "long": {
            "few": "{0} jardai",
            "many": "{0} jardo",
            "one": "{0} jardas",
            "other": "{0} jardų"
          },
          "narrow": {
            "other": "{0} yd"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} yd"
          }
        },
        "year": {
          "long": {
            "few": "{0} metai",
            "one": "{0} metai",
            "other": "{0} metų"
          },
          "narrow": {
            "other": "{0} m."
          },
          "perUnit": {
            "long": "{0} per metus",
            "narrow": "{0}/m.",
            "short": "{0}/m."
          },
          "short": {
            "other": "{0} m."
          }
        }
      }
    }
  },
  "locale": "lt"
})
}